import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className='body-privacity-element'>
	<div><strong><span style={{fontSize: '26px'}}><span data-custom-class="title">
              <span className="block-component" />
              <span className="question">PRIVACY POLICY</span>
              <span className="statement-end-if-in-editor" />
            </span></span></strong></div>
	<div><br /></div>
	<div><span style={{color: '#f3f3f3f3'}}><strong><span style={{fontSize: '15px'}}><span data-custom-class="subtitle">Last updated <span className="question">July 03, 2024</span>
		</span>
		</span>
		</strong>
		</span>
	</div>
	<div><br /></div>
	<div><br /></div>
	<div><br /></div>
	<div style={{lineHeight: '1.5'}}><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">This privacy notice
              for <span className="question">NTKC LLC<span className="block-component" />
              </span> (<span className="block-component" />"<strong>we</strong>," "<strong>us</strong>," or "
		<strong>our</strong>"<span className="statement-end-if-in-editor" /></span><span data-custom-class="body_text">), describes how and why we might collect, store, use, and/or share (
              <span className="block-component" />"<strong>process</strong>"<span className="statement-end-if-in-editor" />) your information when you use our services (<span className="block-component" />"<strong>Services</strong>"<span className="statement-end-if-in-editor" />), such as when you:</span></span>
		</span><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                  <span className="block-component" />
                </span></span>
		</span>
		</span>
		</span>
		<div>
			<span className="block-component"><span style={{fontSize: '15px'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                        <span className="block-component" />
                      </span></span>
			</span>
			</span>
			</span>
			</span>
			</span>
		</div>
		<ul>
			<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Download
                  and use<span className="block-component" /> our mobile application<span className="block-component" /> (<span className="question">meeteasy)<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}>
                                    <span className="statement-end-if-in-editor">,</span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}>
                            <span className="statement-end-if-in-editor">
                              <span className="block-component"> or any other application of ours that
                                links to this privacy notice</span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span>
			</li>
		</ul>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                    <span className="block-component" />
                  </span></span>
			</span>
			</span>
			</span>
		</div>
		<ul>
			<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Engage with
                  us in other related ways, including any sales, marketing, or events<span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}>
                            <span className="statement-end-if-in-editor" />
                          </span></span>
				</span>
				</span>
				</span>
				</span>
				</span>
				</span>
			</li>
		</ul>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3f3'}}><span data-custom-class="body_text"><strong>Questions or concerns?\'a0</strong>Reading this privacy
                notice will help you understand your privacy rights and choices. If you do not agree with our
                policies and practices, please do not use our Services.<span className="block-component" /> If
                you still have any questions or concerns, please contact us at <span className="question">
                  NTKCLLC@gmail.com</span>.</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><strong><span style={{fontSize: '15px'}}><span data-custom-class="heading_1">SUMMARY OF KEY POINTS</span></span></strong></div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong><em>This summary provides key points from our privacy notice,
                  but you can find out more details about any of these topics by clicking the link following
                  each key point or by using our\'a0</em></strong></span></span><a data-custom-class="link" href="#toc"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text"><strong><em>table of contents</em></strong></span></span></a><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong><em>\'a0below to find the section
                  you are looking for.</em></strong></span></span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>What personal information do we process?</strong> When you
              visit, use, or navigate our Services, we may process personal information depending on how you
              interact with us and the Services, the choices you make, and the products and features you use.
              Learn more about\'a0</span></span><a data-custom-class="link" href="#personalinfo"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text">personal
                information you disclose to us</span></span></a><span data-custom-class="body_text">.</span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>Do
                we process any sensitive personal information?</strong>
              <span className="block-component" />We may process sensitive personal information when necessary
              with your consent or as otherwise permitted by applicable law. Learn more about\'a0
            </span></span><a data-custom-class="link" href="#sensitiveinfo"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text">sensitive
                information we process</span></span></a><span data-custom-class="body_text">.</span><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
              <span className="statement-end-if-in-editor" />
            </span></span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>Do
                we collect any information from third parties?</strong>
              <span className="block-component" />We do not collect any information from third parties.<span className="else-block" />
            </span></span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>How
                do we process your information?</strong> We process your information to provide, improve, and
              administer our Services, communicate with you, for security and fraud prevention, and to comply with
              law. We may also process your information for other purposes with your consent. We process your
              information only when we have a valid legal reason to do so. Learn more about\'a0</span></span><a data-custom-class="link" href="#infouse"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text">how we process your information</span></span></a><span data-custom-class="body_text">.</span></div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>In
                what situations and with which <span className="block-component" />parties do we share personal
                information?</strong> We may share information in specific situations and with specific <span className="block-component" />third parties. Learn more about\'a0</span></span><a data-custom-class="link" href="#whoshare"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text">when and with
                whom we share your personal information</span></span></a><span style={{fontSize: '15px'}}><span data-custom-class="body_text">.<span className="block-component" /></span></span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>How
                do we keep your information safe?</strong> We have <span className="block-component" />
              organizational<span className="statement-end-if-in-editor" /> and technical processes and procedures
              in place to protect your personal information. However, no electronic transmission over the internet
              or information storage technology can be guaranteed to be 100% secure, so we cannot promise or
              guarantee that hackers, cybercriminals, or other <span className="block-component" />unauthorized
              <span className="statement-end-if-in-editor" /> third parties will not be able to defeat our
              security and improperly collect, access, steal, or modify your information. Learn more
              about\'a0</span></span><a data-custom-class="link" href="#infosafe"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text">how we keep
                your information safe</span></span></a><span data-custom-class="body_text">.</span><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
              <span className="statement-end-if-in-editor" />
            </span></span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>What are your rights?</strong> Depending on where you are
              located geographically, the applicable privacy law may mean you have certain rights regarding your
              personal information. Learn more about\'a0</span></span><a data-custom-class="link" href="#privacyrights"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text">your privacy rights</span></span></a><span data-custom-class="body_text">.</span></div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>How
                do you exercise your rights?</strong> The easiest way to exercise your rights is by <span className="block-component">submitting a\'a0</span></span>
			</span><a data-custom-class="link" href="https://app.termly.io/notify/6c84b209-c0a2-4278-8690-da91c4609e50" rel="noopener noreferrer" target="_blank"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text">data subject access request</span></span></a><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
              <span className="block-component" />, or by contacting us. We will consider and act upon any request
              in accordance with applicable data protection laws.
            </span></span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text">Want to
              learn more about what we do with any information we collect?\'a0</span></span><a data-custom-class="link" href="#toc"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text">Review the privacy notice in full</span></span></a><span style={{fontSize: '15px'}}><span data-custom-class="body_text">.</span></span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div id="toc" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3f3'}}><span style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">TABLE OF CONTENTS</span></strong>
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#infocollect"><span style={{color: 'rgb(0, 58, 250)'}}>1. WHAT INFORMATION DO WE
                COLLECT?</span></a>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#infouse"><span style={{color: 'rgb(0, 58, 250)'}}>2. HOW DO WE PROCESS YOUR INFORMATION?<span className="block-component" /></span></a>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span style={{color: 'rgb(0, 58, 250)'}}><a data-custom-class="link" href="#whoshare">3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL
                INFORMATION?</a></span><span data-custom-class="body_text">
              <span className="block-component" />
            </span></span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><a data-custom-class="link" href="#3pwebsites">4. WHAT IS OUR STANCE ON THIRD-PARTY WEBSITES?<span className="statement-end-if-in-editor" /></a><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}>
                    <span className="block-component" />
                  </span></span>
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#cookies"><span style={{color: 'rgb(0, 58, 250)'}}>5. DO WE USE COOKIES AND OTHER TRACKING
                TECHNOLOGIES?</span></a><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}>
                    <span className="statement-end-if-in-editor" />
                  </span></span><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span style={{color: '#f3f3f3'}}><span style={{color: '#f3f3f3'}}>
                        <span className="block-component" />
                      </span></span>
			</span>
			</span>
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#sociallogins"><span style={{color: 'rgb(0, 58, 250)'}}><span style={{color: 'rgb(0, 58, 250)'}}><span style={{color: 'rgb(0, 58, 250)'}}>6. HOW DO WE HANDLE
                    YOUR SOCIAL LOGINS?</span></span>\'a0</span>\'a0</a><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span style={{color: '#f3f3f3'}}><span style={{color: '#f3f3f3'}}>
                        <span className="statement-end-if-in-editor" />
                      </span></span>
			<span className="block-component" />
			</span>
			</span>
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#inforetain"><span style={{color: 'rgb(0, 58, 250)'}}>7. HOW LONG DO WE KEEP YOUR
                INFORMATION?</span></a><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span style={{color: '#f3f3f3'}}>
                      <span className="block-component" />
                    </span></span>
			</span>
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#infosafe"><span style={{color: 'rgb(0, 58, 250)'}}>8. HOW DO WE KEEP YOUR INFORMATION
                SAFE?</span></a><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}>
                    <span className="statement-end-if-in-editor" />
                    <span className="block-component" />
                  </span></span>
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#infominors"><span style={{color: 'rgb(0, 58, 250)'}}>9. DO WE COLLECT INFORMATION FROM
                MINORS?</span></a><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}>
                    <span className="statement-end-if-in-editor" />
                  </span></span>
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span style={{color: 'rgb(0, 58, 250)'}}><a data-custom-class="link" href="#privacyrights">10. WHAT ARE YOUR PRIVACY
                RIGHTS?</a></span></span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#DNT"><span style={{color: 'rgb(0, 58, 250)'}}>11. CONTROLS FOR DO-NOT-TRACK FEATURES<span className="block-component" /></span></a>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#uslaws"><span style={{color: 'rgb(0, 58, 250)'}}>12. DO UNITED STATES RESIDENTS HAVE SPECIFIC
                PRIVACY RIGHTS?</span></a>
			</span>
			<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" />
            </span></span>
		</div>
		<div style={{lineHeight: '1.5'}}>
			<span className="block-component"><span style={{fontSize: '15px'}} /></span>
			<span className="block-component" />
			<span className="block-component" />
			<span className="block-component" />
			<span className="block-component" />
			<span className="block-component" />
			<span className="block-component" />
			<span className="block-component" />
			<span className="block-component" />
			<span className="block-component" />
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><a data-custom-class="link" href="#policyupdates"><span style={{color: 'rgb(0, 58, 250)'}}>13. DO WE MAKE UPDATES TO THIS
                NOTICE?</span></a>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><a data-custom-class="link" href="#contact"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}>14. HOW CAN YOU CONTACT US ABOUT THIS
              NOTICE?</span></a></div>
		<div style={{lineHeight: '1.5'}}><a data-custom-class="link" href="#request"><span style={{color: 'rgb(0, 58, 250)'}}>15. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
              YOU?</span></a></div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div id="infocollect" style={{lineHeight: '1.5'}}><span style={{color: 'rgb(0, 0, 0)'}}><span style={{color: 'rgb(0, 0, 0)', fontSize: '15px'}}><span style={{fontSize: '15px', color: 'rgb(0, 0, 0)'}}><span style={{fontSize: '15px', color: 'rgb(0, 0, 0)'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">1. WHAT
                        INFORMATION DO WE COLLECT?</span></strong>
			</span>
			</span>
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div id="personalinfo" style={{lineHeight: '1.5'}}><span data-custom-class="heading_2" style={{color: 'rgb(0, 0, 0)'}}><span style={{fontSize: '15px'}}><strong>Personal information you disclose
                to us</strong></span></span>
		</div>
		<div>
			<div><br /></div>
			<div style={{lineHeight: '1.5'}}><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                            Short:</em></strong></span></span>
				</span>
				</span><span data-custom-class="body_text"><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>\'a0</em></strong><em>We collect
                          personal information that you provide to
                          us.</em></span></span>
				</span>
				</span>
				</span>
				</span>
			</div>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We collect
                personal information that you voluntarily provide to us when you <span style={{fontSize: '15px'}}>
                  <span className="block-component" />
                </span>register on the Services,\'a0</span><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}>
                    <span className="statement-end-if-in-editor" />
                  </span></span><span data-custom-class="body_text">express an interest in obtaining
                  information about us or our products and Services, when you participate in activities on the
                  Services, or otherwise when you contact us.</span></span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}>
                  <span className="block-component" />
                </span></span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong>Personal Information Provided by You.</strong> The
                personal information that we collect depends on the context of your interactions with us and the
                Services, the choices you make, and the products and features you use. The personal information
                we collect may include the following:<span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                    <span className="forloop-component" />
                  </span></span>
			</span>
			</span>
			</span>
		</div>
		<ul>
			<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                      <span className="question">names</span>
				</span>
				</span>
				</span>
				</span>
				</span>
			</li>
		</ul>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                    <span className="forloop-component" />
                  </span></span>
			</span>
			</span>
			</span>
		</div>
		<ul>
			<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                      <span className="question">email addresses</span>
				</span>
				</span>
				</span>
				</span>
				</span>
			</li>
		</ul>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                    <span className="forloop-component" />
                  </span></span>
			</span>
			</span>
			</span>
		</div>
		<ul>
			<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                      <span className="question">passwords</span>
				</span>
				</span>
				</span>
				</span>
				</span>
			</li>
		</ul>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                    <span className="forloop-component" />
                  </span></span>
			</span>
			</span>
			</span>
		</div>
		<ul>
			<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                      <span className="question">usernames</span>
				</span>
				</span>
				</span>
				</span>
				</span>
			</li>
		</ul>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                    <span className="forloop-component" />
                  </span><span data-custom-class="body_text">
                    <span className="statement-end-if-in-editor" />
                  </span></span>
			</span>
			</span>
			</span>
		</div>
		<div id="sensitiveinfo" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>Sensitive Information.</strong>
              <span className="block-component" />When necessary, with your consent or as otherwise permitted by
              applicable law, we process the following categories of sensitive information:<span className="forloop-component" />
            </span></span>
		</div>
		<ul>
			<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                <span className="question">data about a person's sex life or sexual orientation</span>
				</span>
				</span>
			</li>
		</ul>
		<div><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
              <span className="forloop-component" />
            </span><span data-custom-class="body_text">
              <span className="statement-end-if-in-editor" />
            </span></span><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                    <span className="block-component">
                      <span className="block-component" />
                    </span>
			</span>
			</span>
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong>Social Media Login Data.\'a0</strong>We may provide you
                with the option to register with us using your existing social media account details, like your
                Facebook, X, or other social media account. If you choose to register in this way, we will
                collect certain profile information about you from the social media provider, as described in
                the section called <span className="block-component" />"<span className="statement-end-if-in-editor" /><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: 'rgb(0, 58, 250)'}}><a data-custom-class="link" href="#sociallogins">HOW DO WE HANDLE YOUR SOCIAL
                          LOGINS?</a></span></span>
			</span>
			</span>
			<span className="block-component" />"<span className="statement-end-if-in-editor" /> below.
			</span>
			</span>
			</span>
		</div>
		<div style={{lineHeight: '1.5'}}><br /></div>
		<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}>
                  <span className="statement-end-if-in-editor">
                    <span className="statement-end-if-in-editor" />
                  </span>
			</span>
			</span>
			</span>
			</span>
			<span className="block-component">
            <span className="block-component" />
          </span>
		</div>
		<div style={{lineHeight: '1.5'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><strong>Application Data.</strong> If you use our application(s), we also
              may collect the following information if you choose to provide us with access or permission:<span className="block-component" /></span></span>
			<div style={{lineHeight: '1.5'}}>
				<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                </span></span>
				</span>
				<div style={{lineHeight: '1.5'}}>
					<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                  </span></span>
					</span>
					<div style={{lineHeight: '1.5'}}>
						<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span></span>
					</div>
					<ul>
						<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><em>Push
                        Notifications.</em> We may request to send you push notifications regarding your
                      account or certain features of the application(s). If you wish to opt out from
                      receiving these types of communications, you may turn them off in your device's
                      settings.<span className="statement-end-if-in-editor" /></span></span>
						</li>
					</ul>
					<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text">This information is primarily needed to maintain the
                    security and operation of our application(s), for troubleshooting, and for our internal
                    analytics and reporting purposes.</span></span>
					</div>
					<div style={{lineHeight: '1.5'}}><br /></div>
					<div style={{lineHeight: '1.5'}}>
						<span className="statement-end-if-in-editor"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span></span>
					</div>
					<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">All personal information that you provide to us must
                      be true, complete, and accurate, and you must notify us of any changes to such
                      personal information.</span></span>
						</span>
					</div>
					<div style={{lineHeight: '1.5'}}><br /></div>
					<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                      <span className="block-component" />
                    </span></span>
						</span>
					</div>
					<div style={{lineHeight: '1.5'}}><span data-custom-class="heading_2" style={{color: 'rgb(0, 0, 0)'}}><span style={{fontSize: '15px'}}><strong>Information
                      automatically collected</strong></span></span>
					</div>
					<div>
						<div><br /></div>
						<div style={{lineHeight: '1.5'}}><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                  Short:</em></strong></span></span>
							</span>
							</span><span data-custom-class="body_text"><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>\'a0</em></strong><em>Some
                                information \'97 such as your Internet Protocol (IP) address
                                and/or browser and device characteristics \'97 is collected
                                automatically when you visit our
                                Services.</em></span></span>
							</span>
							</span>
							</span>
							</span>
						</div>
					</div>
					<div style={{lineHeight: '1.5'}}><br /></div>
					<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We automatically collect certain information when you
                      visit, use, or navigate the Services. This information does not reveal your specific
                      identity (like your name or contact information) but may include device and usage
                      information, such as your IP address, browser and device characteristics, operating
                      system, language preferences, referring URLs, device name, country, location,
                      information about how and when you use our Services, and other technical
                      information. This information is primarily needed to maintain the security and
                      operation of our Services, and for our internal analytics and reporting
                      purposes.</span></span>
						</span>
					</div>
					<div style={{lineHeight: '1.5'}}><br /></div>
					<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                      <span className="block-component">
                      </span></span>
						</span><span data-custom-class="body_text">
                    <span className="block-component" />
                  </span></span>
					</div>
					<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">The information we collect includes:<span className="block-component" /></span></span>
						</span>
					</div>
					<ul>
						<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><em>Log and Usage Data.</em> Log and usage data
                        is service-related, diagnostic, usage, and performance information our servers
                        automatically collect when you access or use our Services and which we record in
                        log files. Depending on how you interact with us, this log data may include your
                        IP address, device information, browser type, and settings and information about
                        your activity in the Services<span style={{fontSize: '15px'}}>\'a0</span>(such as the date/time stamps associated with your usage, pages and files viewed, searches, and other actions you take such as which features you use), device event information (such as system activity, error reports (sometimes called <span className="block-component" />"crash dumps"<span className="statement-end-if-in-editor" />), and hardware settings).<span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}>
                                  <span className="statement-end-if-in-editor" />
                                </span></span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
						</li>
					</ul>
					<div style={{lineHeight: '1.5'}}>
						<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span></span>
					</div>
					<ul>
						<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><em>Device Data.</em> We collect device data such
                        as information about your computer, phone, tablet, or other device you use to
                        access the Services. Depending on the device used, this device data may include
                        information such as your IP address (or proxy server), device and application
                        identification numbers, location, browser type, hardware model, Internet service
                        provider and/or mobile carrier, operating system, and system configuration
                        information.<span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}>
                                  <span className="statement-end-if-in-editor" />
                                </span></span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
						</li>
					</ul>
					<div style={{lineHeight: '1.5'}}>
						<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span></span>
					</div>
					<ul>
						<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><em>Location Data.</em> We collect location data
                        such as information about your device's location, which can be either precise or
                        imprecise. How much information we collect depends on the type and settings of
                        the device you use to access the Services. For example, we may use GPS and other
                        technologies to collect geolocation data that tells us your current location
                        (based on your IP address). You can opt out of allowing us to collect this
                        information either by refusing access to the information or by disabling your
                        Location setting on your device. However, if you choose to opt out, you may not
                        be able to use certain aspects of the Services.<span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}>
                                  <span className="statement-end-if-in-editor" />
                                </span></span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
						</li>
					</ul>
					<div>
						<span className="block-component"><span style={{fontSize: '15px'}} /></span>
						<span className="statement-end-if-in-editor" />
						<span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                          <span className="statement-end-if-in-editor">
                            <span className="block-component" />
                          </span>
						</span>
						</span>
						</span>
						</span>
						</span><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                    <span className="block-component" />
                  </span></span>
					</div>
					<div style={{lineHeight: '1.5'}}><br /></div>
					<div id="infouse" style={{lineHeight: '1.5'}}><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">2. HOW DO WE PROCESS YOUR
                              INFORMATION?</span></strong>
						</span>
						</span>
						</span>
						</span>
						</span>
					</div>
					<div>
						<div style={{lineHeight: '1.5'}}><br /></div>
						<div style={{lineHeight: '1.5'}}><span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                  Short:\'a0</em></strong><em>We process your information to
                                provide, improve, and administer our Services, communicate with
                                you, for security and fraud prevention, and to comply with law.
                                We may also process your information for other purposes with
                                your consent.</em></span></span>
							</span>
							</span>
							</span>
							</span>
						</div>
					</div>
					<div style={{lineHeight: '1.5'}}><br /></div>
					<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong>We process your personal information for a
                        variety of reasons, depending on how you interact with our Services,
                        including:</strong>
                      <span className="block-component" />
                    </span></span>
						</span>
					</div>
					<ul>
						<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong>To facilitate account creation and
                          authentication and otherwise manage user accounts.\'a0</strong>We may
                        process your information so you can create and log in to your account, as well
                        as keep your account in working order.<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                          <span className="statement-end-if-in-editor">
                                          </span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
							</span>
						</li>
					</ul>
					<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                      <span className="block-component" />
                    </span></span>
						</span>
						<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                        <span className="block-component" />
                      </span></span>
							</span>
							<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                          <span className="block-component" />
                        </span></span>
								</span>
							</div>
							<ul>
								<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong>To respond to user
                              inquiries/offer support to users.\'a0</strong>We may process your
                            information to respond to your inquiries and solve any potential issues
                            you might have with the requested service.<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                              <span className="statement-end-if-in-editor">
                                              </span>
									</span>
									</span>
									</span>
									</span>
									</span>
									</span>
									</span>
									</span>
									</span>
									</span>
									</span>
									</span>
								</li>
							</ul>
							<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                          <span className="block-component" />
                        </span></span>
								</span>
								<div style={{lineHeight: '1.5'}}>
									<span className="block-component"><span style={{fontSize: '15px'}} /></span>
									<div style={{lineHeight: '1.5'}}>
										<span className="block-component"><span style={{fontSize: '15px'}} /></span>
										<div style={{lineHeight: '1.5'}}>
											<span className="block-component"><span style={{fontSize: '15px'}} /></span>
											<div style={{lineHeight: '1.5'}}>
												<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span></span>
												<p style={{fontSize: '15px', lineHeight: '1.5'}}>
													<span className="block-component"><span style={{fontSize: '15px'}} /></span>
												</p>
												<p style={{fontSize: '15px', lineHeight: '1.5'}}>
													<span className="block-component"><span style={{fontSize: '15px'}} /></span>
												</p>
												<p style={{fontSize: '15px', lineHeight: '1.5'}}>
													<span className="block-component" />
												</p>
												<p style={{fontSize: '15px', lineHeight: '1.5'}}>
													<span className="block-component" />
												</p>
												<div style={{lineHeight: '1.5'}}>
													<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span></span>
												</div>
												<ul>
													<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>To send you
                                      marketing and promotional
                                      communications.\'a0</strong>We may process the
                                    personal information you send to us for our marketing
                                    purposes, if this is in accordance with your marketing
                                    preferences. You can opt out of our marketing emails at
                                    any time. For more information, see <span className="block-component" />"<span className="statement-end-if-in-editor" />
                                  </span></span><a href="#privacyrights"><span data-custom-class="link"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="link">WHAT ARE YOUR PRIVACY
                                        RIGHTS?</span></span></span></a><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                    <span className="block-component" />"<span className="statement-end-if-in-editor" /> below.
                                  </span>
														<span className="statement-end-if-in-editor"><span data-custom-class="body_text" /></span>
														</span>
													</li>
												</ul>
												<div style={{lineHeight: '1.5'}}>
													<span className="block-component"><span style={{fontSize: '15px'}} /></span>
													<div style={{lineHeight: '1.5'}}>
														<span className="block-component"><span style={{fontSize: '15px'}}>
                                  </span></span>
														<div style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}>
                                    <span className="block-component"><span data-custom-class="body_text" /></span>
															</span>
															<div style={{lineHeight: '1.5'}}>
																<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span></span>
																<div style={{lineHeight: '1.5'}}>
																	<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																	</span>
																	<div style={{lineHeight: '1.5'}}>
																		<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																		</span>
																		<div style={{lineHeight: '1.5'}}>
																			<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																			</span>
																			<div style={{lineHeight: '1.5'}}>
																				<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																				</span>
																			</div>
																			<ul>
																				<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><strong>To
                                                    evaluate and improve our
                                                    Services, products,
                                                    marketing, and your
                                                    experience.</strong> We
                                                  may process your information
                                                  when we believe it is
                                                  necessary to identify usage
                                                  trends, determine the
                                                  effectiveness of our
                                                  promotional campaigns, and
                                                  to evaluate and improve our
                                                  Services, products,
                                                  marketing, and your
                                                  experience.</span></span>
																					<span className="statement-end-if-in-editor">
                                                <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																					</span>
																				</li>
																			</ul>
																			<div style={{lineHeight: '1.5'}}>
																				<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																				</span>
																			</div>
																			<ul>
																				<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><strong>To
                                                    identify usage
                                                    trends.</strong> We may
                                                  process information about
                                                  how you use our Services to
                                                  better understand how they
                                                  are being used so we can
                                                  improve them.</span></span>
																					<span className="statement-end-if-in-editor">
                                                <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																					</span>
																				</li>
																			</ul>
																			<div style={{lineHeight: '1.5'}}>
																				<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																				</span>
																				<div style={{lineHeight: '1.5'}}>
																					<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																					</span>
																				</div>
																				<ul>
																					<li data-custom-class="body_text" style={{lineHeight: '1.5'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>To
                                                      determine the
                                                      effectiveness of our
                                                      marketing and
                                                      promotional
                                                      campaigns.</strong>
                                                    We may process your
                                                    information to better
                                                    understand how to
                                                    provide marketing and
                                                    promotional campaigns
                                                    that are most relevant
                                                    to you.<span className="statement-end-if-in-editor">
                                                    </span></span>
																						</span>
																					</li>
																				</ul>
																				<div style={{lineHeight: '1.5'}}>
																					<span className="block-component"><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                  </span></span>
																					</span>
																					<div style={{lineHeight: '1.5'}}>
																						<span className="block-component">
                                                  <span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                    </span></span>
																						</span>
																						<div style={{lineHeight: '1.5'}}>
																							<span className="block-component">
                                                    <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																							</span>
																							<div style={{lineHeight: '1.5'}}>
																								<span className="block-component">
                                                      <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																								</span>
																								<span className="block-component">
                                                      <span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                        </span></span>
																								</span>
																								<span className="block-component">
                                                      <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																								</span>
																								<span className="block-component">
                                                      <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																								</span>
																							</div>
																							<div style={{lineHeight: '1.5'}}>
																								<br /></div>
																							<div id="whoshare" style={{lineHeight: '1.5'}}>
																								<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">3.
                                                                  WHEN
                                                                  AND
                                                                  WITH
                                                                  WHOM
                                                                  DO
                                                                  WE
                                                                  SHARE
                                                                  YOUR
                                                                  PERSONAL
                                                                  INFORMATION?</span></strong>
																								</span>
																								</span>
																								</span>
																								</span>
																								</span>
																							</div>
																							<div style={{lineHeight: '1.5'}}>
																								<br /></div>
																							<div style={{lineHeight: '1.5'}}>
																								<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                                              Short:</em></strong><em>\'a0We
                                                            may
                                                            share
                                                            information
                                                            in
                                                            specific
                                                            situations
                                                            described
                                                            in this
                                                            section
                                                            and/or
                                                            with the
                                                            following
                                                            <span className="block-component">
                                                            </span> third parties.
																								</em>
																								</span>
																								</span>
																								</span>
																							</div>
																							<div style={{lineHeight: '1.5'}}>
																								<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                          <span className="block-component">
                                                          </span></span>
																								</span>
																								</span>
																							</div>
																							<div style={{lineHeight: '1.5'}}>
																								<br /></div>
																							<div style={{lineHeight: '1.5'}}>
																								<span style={{fontSize: '15px'}}><span data-custom-class="body_text">We
                                                        <span className="block-component">
                                                        </span>may need to share your personal information in the following situations:
																								</span>
																								</span>
																							</div>
																							<ul>
																								<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																									<span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong>Business
                                                            Transfers.</strong>
                                                          We may share
                                                          or transfer
                                                          your
                                                          information
                                                          in
                                                          connection
                                                          with, or
                                                          during
                                                          negotiations
                                                          of, any
                                                          merger, sale
                                                          of company
                                                          assets,
                                                          financing,
                                                          or
                                                          acquisition
                                                          of all or a
                                                          portion of
                                                          our business
                                                          to another
                                                          company.</span></span>
																								</li>
																							</ul>
																							<div style={{lineHeight: '1.5'}}>
																								<span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                        <span className="block-component">
                                                        </span>
																								</span>
																								</span>
																								<div style={{lineHeight: '1.5'}}>
																									<span style={{fontSize: '15px'}}>
                                                        <span className="block-component">
                                                          <span data-custom-class="body_text" />
                                                        </span>
																									</span>
																									<div style={{lineHeight: '1.5'}}>
																										<span className="block-component">
                                                          <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																										</span>
																										<div style={{lineHeight: '1.5'}}>
																											<span className="block-component">
                                                            <span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                              </span></span>
																											</span>
																											<div style={{lineHeight: '1.5'}}>
																												<span className="block-component">
                                                              <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																												</span>
																												<span data-custom-class="body_text"><span style={{fontSize: '15px'}}>
                                                                <span className="block-component">
                                                                </span>
																												</span>
																												</span>
																												<span className="statement-end-if-in-editor">
                                                              <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																												</span>
																												<div style={{lineHeight: '1.5'}}>
																													<span className="block-component">
                                                                <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<strong><span id="3pwebsites" style={{fontSize: '15px'}}><span data-custom-class="heading_1">4.
                                                                    WHAT
                                                                    IS
                                                                    OUR
                                                                    STANCE
                                                                    ON
                                                                    THIRD-PARTY
                                                                    WEBSITES?</span></span></strong>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong><em>In
                                                                      Short:</em></strong><em>\'a0We
                                                                    are
                                                                    not
                                                                    responsible
                                                                    for
                                                                    the
                                                                    safety
                                                                    of
                                                                    any
                                                                    information
                                                                    that
                                                                    you
                                                                    share
                                                                    with
                                                                    third
                                                                    parties
                                                                    that
                                                                    we
                                                                    may
                                                                    link
                                                                    to
                                                                    or
                                                                    who
                                                                    advertise
                                                                    on
                                                                    our
                                                                    Services,
                                                                    but
                                                                    are
                                                                    not
                                                                    affiliated
                                                                    with,
                                                                    our
                                                                    Services.</em></span></span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text">The
                                                                  Services
                                                                  <span className="block-component">
                                                                  </span>
																													<span className="block-component">
                                                                  </span>
																													<span className="statement-end-if-in-editor">
                                                                  </span> may link to third-party websites, online services, or mobile applications and/or contain advertisements from third parties that are not affiliated with us and which may link to other websites, services, or applications. Accordingly, we do not make any guarantee regarding any such third parties, and we will not be liable for any loss or damage caused by the use of such third-party websites, services, or applications. The inclusion of a link towards a third-party website, service, or application does not imply an endorsement by us. We cannot guarantee the safety and privacy of data you provide to any third parties. Any data collected by third parties is not covered by this privacy notice. We are not responsible for the content or privacy and security practices and policies of any third parties, including other websites, services, or applications that may be linked to or from the Services. You should review the policies of such third parties and contact them directly to respond to your questions.
																													</span>
																													</span>
																													<span className="statement-end-if-in-editor">
                                                                <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																													</span>
																													<span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}>
                                                                        <span className="block-component">
                                                                          <span data-custom-class="heading_1">
                                                                            <span className="block-component">
                                                                            </span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div id="cookies" style={{lineHeight: '1.5'}}>
																													<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">5.
                                                                            DO
                                                                            WE
                                                                            USE
                                                                            COOKIES
                                                                            AND
                                                                            OTHER
                                                                            TRACKING
                                                                            TECHNOLOGIES?</span></strong>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                                                        Short:</em></strong><em>\'a0We
                                                                      may
                                                                      use
                                                                      cookies
                                                                      and
                                                                      other
                                                                      tracking
                                                                      technologies
                                                                      to
                                                                      collect
                                                                      and
                                                                      store
                                                                      your
                                                                      information.</em></span></span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                    may
                                                                    use
                                                                    cookies
                                                                    and
                                                                    similar
                                                                    tracking
                                                                    technologies
                                                                    (like
                                                                    web
                                                                    beacons
                                                                    and
                                                                    pixels)
                                                                    to
                                                                    gather
                                                                    information
                                                                    when
                                                                    you
                                                                    interact
                                                                    with
                                                                    our
                                                                    Services.
                                                                    Some
                                                                    online
                                                                    tracking
                                                                    technologies
                                                                    help
                                                                    us
                                                                    maintain
                                                                    the
                                                                    security
                                                                    of
                                                                    our
                                                                    Services
                                                                    <span className="block-component">
                                                                    </span> and your account
																													<span className="statement-end-if-in-editor">
                                                                    </span> , prevent crashes, fix bugs, save your preferences, and assist with basic site functions.
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                    also
                                                                    permit
                                                                    third
                                                                    parties
                                                                    and
                                                                    service
                                                                    providers
                                                                    to
                                                                    use
                                                                    online
                                                                    tracking
                                                                    technologies
                                                                    on
                                                                    our
                                                                    Services
                                                                    for
                                                                    analytics
                                                                    and
                                                                    advertising,
                                                                    including
                                                                    to
                                                                    help
                                                                    manage
                                                                    and
                                                                    display
                                                                    advertisements,
                                                                    to
                                                                    tailor
                                                                    advertisements
                                                                    to
                                                                    your
                                                                    interests,
                                                                    or
                                                                    to
                                                                    send
                                                                    abandoned
                                                                    shopping
                                                                    cart
                                                                    reminders
                                                                    (depending
                                                                    on
                                                                    your
                                                                    communication
                                                                    preferences).
                                                                    The
                                                                    third
                                                                    parties
                                                                    and
                                                                    service
                                                                    providers
                                                                    use
                                                                    their
                                                                    technology
                                                                    to
                                                                    provide
                                                                    advertising
                                                                    about
                                                                    products
                                                                    and
                                                                    services
                                                                    tailored
                                                                    to
                                                                    your
                                                                    interests
                                                                    which
                                                                    may
                                                                    appear
                                                                    either
                                                                    on
                                                                    our
                                                                    Services
                                                                    or
                                                                    on
                                                                    other
                                                                    websites.</span></span>
																													</span>
																													<span className="block-component">
                                                                <span style={{fontSize: '15px'}} />
                                                              </span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><br /></span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text">To
                                                                  the
                                                                  extent
                                                                  these
                                                                  online
                                                                  tracking
                                                                  technologies
                                                                  are
                                                                  deemed
                                                                  to
                                                                  be
                                                                  a
                                                                  <span className="block-component">
                                                                  </span> "sale"/"sharing"
																													<span className="statement-end-if-in-editor">
                                                                  </span> (which includes targeted advertising, as defined under the applicable laws) under applicable US state laws, you can opt out of these online tracking technologies by submitting a request as described below under section
																													<span className="block-component">
                                                                  </span> "
																													<span className="statement-end-if-in-editor">
                                                                  </span>
																													</span>
																													</span><span data-custom-class="body_text"><a data-custom-class="link" href="#uslaws"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}>DO
                                                                    UNITED
                                                                    STATES
                                                                    RESIDENTS
                                                                    HAVE
                                                                    SPECIFIC
                                                                    PRIVACY
                                                                    RIGHTS?</span></a>
																													</span><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                                  <span className="block-component">
                                                                  </span> "
																													<span className="statement-end-if-in-editor">
                                                                  </span>
																													</span>
																													<span className="statement-end-if-in-editor">
                                                                </span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Specific
                                                                    information
                                                                    about
                                                                    how
                                                                    we
                                                                    use
                                                                    such
                                                                    technologies
                                                                    and
                                                                    how
                                                                    you
                                                                    can
                                                                    refuse
                                                                    certain
                                                                    cookies
                                                                    is
                                                                    set
                                                                    out
                                                                    in
                                                                    our
                                                                    Cookie
                                                                    Notice<span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                        <span className="block-component">
                                                                        </span> .
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													<span className="block-component">
                                                                <span style={{fontSize: '15px'}} />
                                                              </span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><br /></span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><strong><span data-custom-class="heading_2">Google
                                                                    Analytics</span></strong>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><br /></span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text">We
                                                                  may
                                                                  share
                                                                  your
                                                                  information
                                                                  with
                                                                  Google
                                                                  Analytics
                                                                  to
                                                                  track
                                                                  and
                                                                  <span className="block-component">
                                                                  </span> analyze
																													<span className="statement-end-if-in-editor">
                                                                  </span> the use of the Services.
																													<span className="block-component">
                                                                  </span> The Google Analytics Advertising Features that we may use include:
																													<span className="forloop-component">
                                                                  </span>
																													<span className="block-component">
                                                                  </span>
																													<span className="question">
                                                                    Remarketing
                                                                    with
                                                                    Google
                                                                    Analytics
                                                                  </span>
																													<span className="block-component">
                                                                  </span>
																													<span className="forloop-component">
                                                                  </span> .
																													<span className="statement-end-if-in-editor">
                                                                  </span> To opt out of being tracked by Google Analytics across the Services, visit
																													<span style={{color: 'rgb(0, 58, 250)'}}></span>
																													<span className="block-component">
                                                                  </span> You can opt out of Google Analytics Advertising Features through
																													<span style={{color: 'rgb(0, 58, 250)'}}><a data-custom-class="link" href="https://adssettings.google.com/" rel="noopener noreferrer" target="_blank">Ads
                                                                      Settings</a></span> and Ad Settings for mobile apps. Other opt out means include
																													<span style={{color: 'rgb(0, 58, 250)'}}></span>
																													and
																													<span style={{color: 'rgb(0, 58, 250)'}}></span>.
																													<span className="statement-end-if-in-editor">
                                                                  </span> For more information on the privacy practices of Google, please visit the
																													<span style={{color: 'rgb(0, 58, 250)'}}><a data-custom-class="link" href="https://policies.google.com/privacy" rel="noopener noreferrer" target="_blank">Google
                                                                      Privacy
                                                                      &amp;
                                                                      Terms
                                                                      page</a></span>.
																													</span>
																													</span>
																													<span className="statement-end-if-in-editor">
                                                                <span style={{fontSize: '15px'}} />
                                                              </span>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                                  <span className="statement-end-if-in-editor">
                                                                                  </span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                                    <span className="block-component">
                                                                                    </span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div id="sociallogins" style={{lineHeight: '1.5'}}>
																													<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">6.
                                                                            HOW
                                                                            DO
                                                                            WE
                                                                            HANDLE
                                                                            YOUR
                                                                            SOCIAL
                                                                            LOGINS?</span></strong>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                                                        Short:\'a0</em></strong><em>If
                                                                      you
                                                                      choose
                                                                      to
                                                                      register
                                                                      or
                                                                      log
                                                                      in
                                                                      to
                                                                      our
                                                                      Services
                                                                      using
                                                                      a
                                                                      social
                                                                      media
                                                                      account,
                                                                      we
                                                                      may
                                                                      have
                                                                      access
                                                                      to
                                                                      certain
                                                                      information
                                                                      about
                                                                      you.</em></span></span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Our
                                                                    Services
                                                                    offer
                                                                    you
                                                                    the
                                                                    ability
                                                                    to
                                                                    register
                                                                    and
                                                                    log
                                                                    in
                                                                    using
                                                                    your
                                                                    third-party
                                                                    social
                                                                    media
                                                                    account
                                                                    details
                                                                    (like
                                                                    your
                                                                    Facebook
                                                                    or
                                                                    X
                                                                    logins).
                                                                    Where
                                                                    you
                                                                    choose
                                                                    to
                                                                    do
                                                                    this,
                                                                    we
                                                                    will
                                                                    receive
                                                                    certain
                                                                    profile
                                                                    information
                                                                    about
                                                                    you
                                                                    from
                                                                    your
                                                                    social
                                                                    media
                                                                    provider.
                                                                    The
                                                                    profile
                                                                    information
                                                                    we
                                                                    receive
                                                                    may
                                                                    vary
                                                                    depending
                                                                    on
                                                                    the
                                                                    social
                                                                    media
                                                                    provider
                                                                    concerned,
                                                                    but
                                                                    will
                                                                    often
                                                                    include
                                                                    your
                                                                    name,
                                                                    email
                                                                    address,
                                                                    friends
                                                                    list,
                                                                    and
                                                                    profile
                                                                    picture,
                                                                    as
                                                                    well
                                                                    as
                                                                    other
                                                                    information
                                                                    you
                                                                    choose
                                                                    to
                                                                    make
                                                                    public
                                                                    on
                                                                    such
                                                                    a
                                                                    social
                                                                    media
                                                                    platform.<span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                    will
                                                                    use
                                                                    the
                                                                    information
                                                                    we
                                                                    receive
                                                                    only
                                                                    for
                                                                    the
                                                                    purposes
                                                                    that
                                                                    are
                                                                    described
                                                                    in
                                                                    this
                                                                    privacy
                                                                    notice
                                                                    or
                                                                    that
                                                                    are
                                                                    otherwise
                                                                    made
                                                                    clear
                                                                    to
                                                                    you
                                                                    on
                                                                    the
                                                                    relevant
                                                                    Services.
                                                                    Please
                                                                    note
                                                                    that
                                                                    we
                                                                    do
                                                                    not
                                                                    control,
                                                                    and
                                                                    are
                                                                    not
                                                                    responsible
                                                                    for,
                                                                    other
                                                                    uses
                                                                    of
                                                                    your
                                                                    personal
                                                                    information
                                                                    by
                                                                    your
                                                                    third-party
                                                                    social
                                                                    media
                                                                    provider.
                                                                    We
                                                                    recommend
                                                                    that
                                                                    you
                                                                    review
                                                                    their
                                                                    privacy
                                                                    notice
                                                                    to
                                                                    understand
                                                                    how
                                                                    they
                                                                    collect,
                                                                    use,
                                                                    and
                                                                    share
                                                                    your
                                                                    personal
                                                                    information,
                                                                    and
                                                                    how
                                                                    you
                                                                    can
                                                                    set
                                                                    your
                                                                    privacy
                                                                    preferences
                                                                    on
                                                                    their
                                                                    sites
                                                                    and
                                                                    apps.<span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                                      <span className="statement-end-if-in-editor">
                                                                                      </span>
																													</span>
																													<span className="block-component">
                                                                                      <span data-custom-class="body_text">
                                                                                        <span className="block-component">
                                                                                        </span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div id="inforetain" style={{lineHeight: '1.5'}}>
																													<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">7.
                                                                            HOW
                                                                            LONG
                                                                            DO
                                                                            WE
                                                                            KEEP
                                                                            YOUR
                                                                            INFORMATION?</span></strong>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                                                        Short:\'a0</em></strong><em>We
                                                                      keep
                                                                      your
                                                                      information
                                                                      for
                                                                      as
                                                                      long
                                                                      as
                                                                      necessary
                                                                      to
                                                                      <span className="block-component">
                                                                      </span> fulfill
																													<span className="statement-end-if-in-editor">
                                                                      </span> the purposes outlined in this privacy notice unless otherwise required by law.
																													</em>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                    will
                                                                    only
                                                                    keep
                                                                    your
                                                                    personal
                                                                    information
                                                                    for
                                                                    as
                                                                    long
                                                                    as
                                                                    it
                                                                    is
                                                                    necessary
                                                                    for
                                                                    the
                                                                    purposes
                                                                    set
                                                                    out
                                                                    in
                                                                    this
                                                                    privacy
                                                                    notice,
                                                                    unless
                                                                    a
                                                                    longer
                                                                    retention
                                                                    period
                                                                    is
                                                                    required
                                                                    or
                                                                    permitted
                                                                    by
                                                                    law
                                                                    (such
                                                                    as
                                                                    tax,
                                                                    accounting,
                                                                    or
                                                                    other
                                                                    legal
                                                                    requirements).
                                                                    <span className="block-component">
                                                                    </span> No purpose in this notice will require us keeping your personal information for longer than
																													<span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																													</span>
																													</span>
																													</span>
																													<span className="block-component">
                                                                    </span> the period of time in which users have an account with us
																													<span className="block-component">
                                                                    </span>
																													<span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                          <span className="else-block">
                                                                          </span>
																													</span>
																													</span>
																													</span>.
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">When
                                                                    we
                                                                    have
                                                                    no
                                                                    ongoing
                                                                    legitimate
                                                                    business
                                                                    need
                                                                    to
                                                                    process
                                                                    your
                                                                    personal
                                                                    information,
                                                                    we
                                                                    will
                                                                    either
                                                                    delete
                                                                    or
                                                                    <span className="block-component">
                                                                    </span> anonymize
																													<span className="statement-end-if-in-editor">
                                                                    </span> such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.
																													<span style={{color: '#f3f3f3'}}>
                                                                      <span className="block-component">
                                                                      </span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div id="infosafe" style={{lineHeight: '1.5'}}>
																													<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">8.
                                                                            HOW
                                                                            DO
                                                                            WE
                                                                            KEEP
                                                                            YOUR
                                                                            INFORMATION
                                                                            SAFE?</span></strong>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                                                        Short:\'a0</em></strong><em>We
                                                                      aim
                                                                      to
                                                                      protect
                                                                      your
                                                                      personal
                                                                      information
                                                                      through
                                                                      a
                                                                      system
                                                                      of
                                                                      <span className="block-component">
                                                                      </span> organizational
																													<span className="statement-end-if-in-editor">
                                                                      </span> and technical security measures.
																													</em>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                    have
                                                                    implemented
                                                                    appropriate
                                                                    and
                                                                    reasonable
                                                                    technical
                                                                    and
                                                                    <span className="block-component">
                                                                    </span> organizational
																													<span className="statement-end-if-in-editor">
                                                                    </span> security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other
																													<span className="block-component">
                                                                    </span> unauthorized
																													<span className="statement-end-if-in-editor">
                                                                    </span> third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. You should only access the Services within a secure environment.
																													<span style={{color: '#f3f3f3'}}>
                                                                      <span className="statement-end-if-in-editor">
                                                                      </span>
																													</span><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                        <span className="block-component">
                                                                        </span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div id="infominors" style={{lineHeight: '1.5'}}>
																													<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">9.
                                                                            DO
                                                                            WE
                                                                            COLLECT
                                                                            INFORMATION
                                                                            FROM
                                                                            MINORS?</span></strong>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                                                        Short:</em></strong><em>\'a0We
                                                                      do
                                                                      not
                                                                      knowingly
                                                                      collect
                                                                      data
                                                                      from
                                                                      or
                                                                      market
                                                                      to
                                                                      <span className="block-component">
                                                                      </span> children under 18 years of age
																													<span className="else-block">
                                                                      </span> .
																													</em>
																													<span className="block-component">
                                                                    </span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                    do
                                                                    not
                                                                    knowingly
                                                                    collect,
                                                                    solicit
                                                                    data
                                                                    from,
                                                                    or
                                                                    market
                                                                    to
                                                                    children
                                                                    under
                                                                    18
                                                                    years
                                                                    of
                                                                    age,
                                                                    nor
                                                                    do
                                                                    we
                                                                    knowingly
                                                                    sell
                                                                    such
                                                                    personal
                                                                    information.
                                                                    By
                                                                    using
                                                                    the
                                                                    Services,
                                                                    you
                                                                    represent
                                                                    that
                                                                    you
                                                                    are
                                                                    at
                                                                    least
                                                                    18
                                                                    or
                                                                    that
                                                                    you
                                                                    are
                                                                    the
                                                                    parent
                                                                    or
                                                                    guardian
                                                                    of
                                                                    such
                                                                    a
                                                                    minor
                                                                    and
                                                                    consent
                                                                    to
                                                                    such
                                                                    minor
                                                                    dependent\'92s
                                                                    use
                                                                    of
                                                                    the
                                                                    Services.
                                                                    If
                                                                    we
                                                                    learn
                                                                    that
                                                                    personal
                                                                    information
                                                                    from
                                                                    users
                                                                    less
                                                                    than
                                                                    18
                                                                    years
                                                                    of
                                                                    age
                                                                    has
                                                                    been
                                                                    collected,
                                                                    we
                                                                    will
                                                                    deactivate
                                                                    the
                                                                    account
                                                                    and
                                                                    take
                                                                    reasonable
                                                                    measures
                                                                    to
                                                                    promptly
                                                                    delete
                                                                    such
                                                                    data
                                                                    from
                                                                    our
                                                                    records.
                                                                    If
                                                                    you
                                                                    become
                                                                    aware
                                                                    of
                                                                    any
                                                                    data
                                                                    we
                                                                    may
                                                                    have
                                                                    collected
                                                                    from
                                                                    children
                                                                    under
                                                                    age
                                                                    18,
                                                                    please
                                                                    contact
                                                                    us
                                                                    at
                                                                    <span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                        <span className="block-component">
                                                                        </span>
																													<span className="question">
                                                                          ntkcllc@gmail.com
                                                                        </span>
																													<span className="else-block">
                                                                        </span>
																													</span>
																													</span>.</span><span data-custom-class="body_text">
                                                                    <span className="else-block">
                                                                      <span className="block-component">
                                                                      </span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div id="privacyrights" style={{lineHeight: '1.5'}}>
																													<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">10.
                                                                            WHAT
                                                                            ARE
                                                                            YOUR
                                                                            PRIVACY
                                                                            RIGHTS?</span></strong>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                                                        Short:</em></strong><em>\'a0<span style={{color: '#f3f3f3'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><em>
                                                                              <span className="block-component">
                                                                              </span>
																													</em>
																													</span>
																													</span>\'a0</span>You may review, change, or terminate your account at any time, depending on your country, province, or state of residence.
																													</em><span style={{color: '#f3f3f3'}}><span style={{fontSize: '15px'}}>
                                                                        <span className="block-component">
                                                                          <span className="block-component">
                                                                          </span></span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div id="withdrawconsent" style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><u>Withdrawing
                                                                        your
                                                                        consent:</u></strong>
                                                                    If
                                                                    we
                                                                    are
                                                                    relying
                                                                    on
                                                                    your
                                                                    consent
                                                                    to
                                                                    process
                                                                    your
                                                                    personal
                                                                    information,
                                                                    <span className="block-component">
                                                                    </span> which may be express and/or implied consent depending on the applicable law,
																													<span className="statement-end-if-in-editor">
                                                                    </span> you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us by using the contact details provided in the section
																													<span className="block-component">
                                                                    </span> "
																													<span className="statement-end-if-in-editor">
                                                                    </span>
																													</span>
																													</span>
																													</span><a data-custom-class="link" href="#contact"><span style={{fontSize: '15px', color: 'rgb(0, 58, 250)'}}><span style={{fontSize: '15px', color: 'rgb(0, 58, 250)'}}><span data-custom-class="body_text">HOW
                                                                      CAN
                                                                      YOU
                                                                      CONTACT
                                                                      US
                                                                      ABOUT
                                                                      THIS
                                                                      NOTICE?</span></span></span></a><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                    <span className="block-component">
                                                                    </span> "
																													<span className="statement-end-if-in-editor">
                                                                    </span> below
																													<span className="block-component">
                                                                    </span> .
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text">However,
                                                                  please
                                                                  note
                                                                  that
                                                                  this
                                                                  will
                                                                  not
                                                                  affect
                                                                  the
                                                                  lawfulness
                                                                  of
                                                                  the
                                                                  processing
                                                                  before
                                                                  its
                                                                  withdrawal
                                                                  nor,
                                                                  <span className="block-component">
                                                                  </span> when applicable law allows,
																													<span className="statement-end-if-in-editor">
                                                                  </span> will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.
																													<span className="block-component">
                                                                  </span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text"><strong><u>Opting
                                                                      out
                                                                      of
                                                                      marketing
                                                                      and
                                                                      promotional
                                                                      communications:</u></strong><strong>\'a0</strong>You
                                                                  can
                                                                  unsubscribe
                                                                  from
                                                                  our
                                                                  marketing
                                                                  and
                                                                  promotional
                                                                  communications
                                                                  at
                                                                  any
                                                                  time
                                                                  by
                                                                  <span className="block-component">
                                                                  </span>
																													<span className="block-component">
                                                                  </span>
																													<span className="block-component">
                                                                  </span> or by contacting us using the details provided in the section
																													<span className="block-component">
                                                                  </span> "
																													<span className="statement-end-if-in-editor">
                                                                  </span>
																													</span>
																													</span><a data-custom-class="link" href="#contact"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><span data-custom-class="body_text">HOW
                                                                    CAN
                                                                    YOU
                                                                    CONTACT
                                                                    US
                                                                    ABOUT
                                                                    THIS
                                                                    NOTICE?</span></span></a><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                                  <span className="block-component">
                                                                  </span> "
																													<span className="statement-end-if-in-editor">
                                                                  </span> below. You will then be removed from the marketing lists. However, we may still communicate with you \'97 for example, to send you service-related messages that are necessary for the administration and use of your account, to respond to service requests, or for other non-marketing purposes.
																													</span><span data-custom-class="body_text">
                                                                  <span className="statement-end-if-in-editor">
                                                                  </span>
																													</span>
																													</span>
																													<span className="block-component">
                                                                <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="heading_2"><strong>Account
                                                                    Information</strong></span></span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span data-custom-class="body_text"><span style={{fontSize: '15px'}}>If
                                                                  you
                                                                  would
                                                                  at
                                                                  any
                                                                  time
                                                                  like
                                                                  to
                                                                  review
                                                                  or
                                                                  change
                                                                  the
                                                                  information
                                                                  in
                                                                  your
                                                                  account
                                                                  or
                                                                  terminate
                                                                  your
                                                                  account,
                                                                  you
                                                                  can:
                                                                  <span className="forloop-component">
                                                                  </span>
																													</span>
																													</span>
																												</div>
																												<ul>
																													<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																														<span data-custom-class="body_text"><span style={{fontSize: '15px'}}>
                                                                    <span className="question">
                                                                      Log
                                                                      in
                                                                      to
                                                                      your
                                                                      account
                                                                      settings
                                                                      and
                                                                      update
                                                                      your
                                                                      user
                                                                      account.
                                                                    </span>
																														</span>
																														</span>
																													</li>
																												</ul>
																												<div style={{lineHeight: '1.5'}}>
																													<span data-custom-class="body_text"><span style={{fontSize: '15px'}}>
                                                                  <span className="forloop-component">
                                                                  </span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text">Upon
                                                                  your
                                                                  request
                                                                  to
                                                                  terminate
                                                                  your
                                                                  account,
                                                                  we
                                                                  will
                                                                  deactivate
                                                                  or
                                                                  delete
                                                                  your
                                                                  account
                                                                  and
                                                                  information
                                                                  from
                                                                  our
                                                                  active
                                                                  databases.
                                                                  However,
                                                                  we
                                                                  may
                                                                  retain
                                                                  some
                                                                  information
                                                                  in
                                                                  our
                                                                  files
                                                                  to
                                                                  prevent
                                                                  fraud,
                                                                  troubleshoot
                                                                  problems,
                                                                  assist
                                                                  with
                                                                  any
                                                                  investigations,
                                                                  enforce
                                                                  our
                                                                  legal
                                                                  terms
                                                                  and/or
                                                                  comply
                                                                  with
                                                                  applicable
                                                                  legal
                                                                  requirements.</span></span>
																													<span className="statement-end-if-in-editor">
                                                                <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																													</span>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span style={{color: '#f3f3f3'}}>
                                                                                  <span className="block-component">
                                                                                  </span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																													<span className="block-component">
                                                                <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span data-custom-class="body_text"><span style={{fontSize: '15px'}}>If
                                                                  you
                                                                  have
                                                                  questions
                                                                  or
                                                                  comments
                                                                  about
                                                                  your
                                                                  privacy
                                                                  rights,
                                                                  you
                                                                  may
                                                                  email
                                                                  us
                                                                  at
                                                                  <span className="question">
                                                                    NTKCLLC@gmail.com
                                                                  </span> .
																													</span>
																													</span>
																													<span className="statement-end-if-in-editor">
                                                                <span style={{fontSize: '15px'}}><span data-custom-class="body_text" /></span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div id="DNT" style={{lineHeight: '1.5'}}>
																													<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">11.
                                                                            CONTROLS
                                                                            FOR
                                                                            DO-NOT-TRACK
                                                                            FEATURES</span></strong>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Most
                                                                    web
                                                                    browsers
                                                                    and
                                                                    some
                                                                    mobile
                                                                    operating
                                                                    systems
                                                                    and
                                                                    mobile
                                                                    applications
                                                                    include
                                                                    a
                                                                    Do-Not-Track
                                                                    (
                                                                    <span className="block-component">
                                                                    </span> "DNT"
																													<span className="statement-end-if-in-editor">
                                                                    </span> ) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage, no uniform technology standard for
																													<span className="block-component">
                                                                    </span> recognizing
																													<span className="statement-end-if-in-editor">
                                                                    </span> and implementing DNT signals has been
																													<span className="block-component">
                                                                    </span> finalized
																													<span className="statement-end-if-in-editor">
                                                                    </span> . As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice.
																													</span>
																													</span>
																													</span>
																													<span className="block-component">
                                                                <span style={{fontSize: '15px'}} />
                                                              </span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><br /></span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text">California
                                                                  law
                                                                  requires
                                                                  us
                                                                  to
                                                                  let
                                                                  you
                                                                  know
                                                                  how
                                                                  we
                                                                  respond
                                                                  to
                                                                  web
                                                                  browser
                                                                  DNT
                                                                  signals.
                                                                  Because
                                                                  there
                                                                  currently
                                                                  is
                                                                  not
                                                                  an
                                                                  industry
                                                                  or
                                                                  legal
                                                                  standard
                                                                  for
                                                                  <span className="block-component">
                                                                  </span> recognizing
																													<span className="statement-end-if-in-editor">
                                                                  </span> or
																													<span className="block-component">
                                                                  </span> honoring
																													<span className="statement-end-if-in-editor">
                                                                  </span> DNT signals, we do not respond to them at this time.
																													</span>
																													</span>
																													<span className="statement-end-if-in-editor">
                                                                <span style={{fontSize: '15px'}} />
                                                              </span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                    <span className="block-component">
                                                                    </span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div id="uslaws" style={{lineHeight: '1.5'}}>
																													<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">12.
                                                                            DO
                                                                            UNITED
                                                                            STATES
                                                                            RESIDENTS
                                                                            HAVE
                                                                            SPECIFIC
                                                                            PRIVACY
                                                                            RIGHTS?</span></strong>
																													</span>
																													</span>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong><em>In
                                                                        Short:\'a0</em></strong><em>If
                                                                      you
                                                                      are
                                                                      a
                                                                      resident
                                                                      of
                                                                      <span className="block-component">
                                                                      </span> California, Colorado, Connecticut, Delaware, Florida, Indiana, Iowa, Kentucky, Montana, New Hampshire, New Jersey, Oregon, Tennessee, Texas, Utah, or Virginia
																													<span className="else-block">
                                                                      </span> , you may have the right to request access to and receive details about the personal information we maintain about you and how we have processed it, correct inaccuracies, get a copy of, or delete your personal information. You may also have the right to withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law. More information is provided below.
																													</em>
																													</span>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><strong><span data-custom-class="heading_2">Categories
                                                                      of
                                                                      Personal
                                                                      Information
                                                                      We
                                                                      Collect</span></strong>
																													</span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                    have
                                                                    collected
                                                                    the
                                                                    following
                                                                    categories
                                                                    of
                                                                    personal
                                                                    information
                                                                    in
                                                                    the
                                                                    past
                                                                    twelve
                                                                    (12)
                                                                    months:</span></span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<table style={{width: '100%'}}>
																													<tbody>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong>Category</strong></span></span>
																																</span>
																															</td>
																															<td style={{width: '51.4385%', borderTop: '1px solid black', borderRight: '1px solid black'}}>
																																<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong>Examples</strong></span></span>
																																</span>
																															</td>
																															<td style={{width: '14.9084%', borderRight: '1px solid black', borderTop: '1px solid black', textAlign: 'center'}}>
																																<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong>Collected</strong></span></span>
																																</span>
																															</td>
																														</tr>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">A.
                                                                            Identifiers</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '51.4385%', borderTop: '1px solid black', borderRight: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Contact
                                                                            details,
                                                                            such
                                                                            as
                                                                            real
                                                                            name,
                                                                            alias,
                                                                            postal
                                                                            address,
                                                                            telephone
                                                                            or
                                                                            mobile
                                                                            contact
                                                                            number,
                                                                            unique
                                                                            personal
                                                                            identifier,
                                                                            online
                                                                            identifier,
                                                                            Internet
                                                                            Protocol
                                                                            address,
                                                                            email
                                                                            address,
                                                                            and
                                                                            account
                                                                            name</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '14.9084%', textAlign: 'center', verticalAlign: 'middle', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                              <span className="block-component">
                                                                              </span>
																																	</span>
																																	NO
																																	<span className="statement-end-if-in-editor">
                                                                              <span className="block-component">
                                                                              </span>
																																	</span>
																																	</span>
																																	</span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																													</tbody>
																												</table>
																												<div style={{lineHeight: '1.5'}}>
																													<span className="block-component">
                                                              </span>
																												</div>
																												<table style={{width: '100%'}}>
																													<tbody>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">B.
                                                                            Personal
                                                                            information
                                                                            as
                                                                            defined
                                                                            in
                                                                            the
                                                                            California
                                                                            Customer
                                                                            Records
                                                                            statute</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '51.4385%', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Name,
                                                                            contact
                                                                            information,
                                                                            education,
                                                                            employment,
                                                                            employment
                                                                            history,
                                                                            and
                                                                            financial
                                                                            information</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '14.9084%', textAlign: 'center', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="forloop-component">
                                                                              <span className="block-component">
                                                                                <span className="block-component">
                                                                                  NO
                                                                                  <span className="statement-end-if-in-editor">
                                                                                    <span className="block-component">
                                                                                    </span>
																																	</span>
																																	</span>
																																	</span>
																																	</span>
																																	</span>
																																	</span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																													</tbody>
																												</table>
																												<div style={{lineHeight: '1.5'}}>
																													<span className="block-component">
                                                              </span>
																												</div>
																												<table style={{width: '100%'}}>
																													<tbody>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span> C
																																	<span className="else-block">
                                                                            </span> . Protected classification characteristics under state or federal law
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '51.4385%', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Gender,
                                                                            age,
                                                                            date
                                                                            of
                                                                            birth,
                                                                            race
                                                                            and
                                                                            ethnicity,
                                                                            national
                                                                            origin,
                                                                            marital
                                                                            status,
                                                                            and
                                                                            other
                                                                            demographic
                                                                            data</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '14.9084%', textAlign: 'center', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																	<span className="forloop-component">
                                                                        <span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span> NO
																																	<span className="statement-end-if-in-editor">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span></span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span> D
																																	<span className="else-block">
                                                                            </span> . Commercial information
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '51.4385%', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Transaction
                                                                            information,
                                                                            purchase
                                                                            history,
                                                                            financial
                                                                            details,
                                                                            and
                                                                            payment
                                                                            information</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '14.9084%', textAlign: 'center', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																	<span className="forloop-component">
                                                                        <span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span> NO
																																	<span className="statement-end-if-in-editor">
                                                                            <span className="block-component">
                                                                            </span></span>
																																	</span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span> E
																																	<span className="else-block">
                                                                            </span> . Biometric information
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '51.4385%', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Fingerprints
                                                                            and
                                                                            voiceprints</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '14.9084%', textAlign: 'center', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																	<span className="forloop-component">
                                                                        <span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                            <span className="block-component">
                                                                              NO
                                                                            </span>
																																	<span className="statement-end-if-in-editor">
                                                                            </span>
																																	<span className="block-component">
                                                                            </span></span>
																																	</span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span> F
																																	<span className="else-block">
                                                                            </span> . Internet or other similar network activity
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '51.4385%', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Browsing
                                                                            history,
                                                                            search
                                                                            history,
                                                                            online
                                                                            <span className="block-component">
                                                                            </span> behavior
																																	<span className="statement-end-if-in-editor">
                                                                            </span> , interest data, and interactions with our and other websites, applications, systems, and advertisements
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '14.9084%', textAlign: 'center', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																	<span className="forloop-component">
                                                                        <span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span> NO
																																	<span className="statement-end-if-in-editor">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span></span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span> G
																																	<span className="else-block">
                                                                            </span> . Geolocation data
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '51.4385%', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Device
                                                                            location</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '14.9084%', textAlign: 'center', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																	<span className="forloop-component">
                                                                        <span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span> NO
																																	<span className="statement-end-if-in-editor">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span></span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span> H
																																	<span className="else-block">
                                                                            </span> . Audio, electronic, sensory, or similar information
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '51.4385%', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Images
                                                                            and
                                                                            audio,
                                                                            video
                                                                            or
                                                                            call
                                                                            recordings
                                                                            created
                                                                            in
                                                                            connection
                                                                            with
                                                                            our
                                                                            business
                                                                            activities</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '14.9084%', textAlign: 'center', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																	<span className="forloop-component">
                                                                        <span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span> NO
																																	<span className="statement-end-if-in-editor">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span></span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																														<tr>
																															<td style={{width: '33.8274%', borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span> I
																																	<span className="else-block">
                                                                            </span> . Professional or employment-related information
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '51.4385%', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Business
                                                                            contact
                                                                            details
                                                                            in
                                                                            order
                                                                            to
                                                                            provide
                                                                            you
                                                                            our
                                                                            Services
                                                                            at
                                                                            a
                                                                            business
                                                                            level
                                                                            or
                                                                            job
                                                                            title,
                                                                            work
                                                                            history,
                                                                            and
                                                                            professional
                                                                            qualifications
                                                                            if
                                                                            you
                                                                            apply
                                                                            for
                                                                            a
                                                                            job
                                                                            with
                                                                            us</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{width: '14.9084%', textAlign: 'center', borderRight: '1px solid black', borderTop: '1px solid black'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																	<span className="forloop-component">
                                                                        <span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span> NO
																																	<span className="statement-end-if-in-editor">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span></span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																														<tr>
																															<td style={{borderLeft: '1px solid black', borderRight: '1px solid black', borderTop: '1px solid black', width: '33.8274%'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span> J
																																	<span className="else-block">
                                                                            </span> . Education Information
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{borderRight: '1px solid black', borderTop: '1px solid black', width: '51.4385%'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Student
                                                                            records
                                                                            and
                                                                            directory
                                                                            information</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{textAlign: 'center', borderRight: '1px solid black', borderTop: '1px solid black', width: '14.9084%'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																	<span className="forloop-component">
                                                                        <span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span> NO
																																	<span className="statement-end-if-in-editor">
                                                                          </span>
																																	<span className="block-component">
                                                                          </span></span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																														<tr>
																															<td style={{borderWidth: '1px', borderColor: 'black', borderStyle: 'solid', width: '33.8274%'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span> K
																																	<span className="else-block">
                                                                            </span> . Inferences drawn from collected personal information
																																	</span>
																																	</span>
																																	</span>
																																</div>
																															</td>
																															<td style={{borderBottom: '1px solid black', borderTop: '1px solid black', borderRight: '1px solid black', width: '51.4385%'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">Inferences
                                                                            drawn
                                                                            from
                                                                            any
                                                                            of
                                                                            the
                                                                            collected
                                                                            personal
                                                                            information
                                                                            listed
                                                                            above
                                                                            to
                                                                            create
                                                                            a
                                                                            profile
                                                                            or
                                                                            summary
                                                                            about,
                                                                            for
                                                                            example,
                                                                            an
                                                                            individual\'92s
                                                                            preferences
                                                                            and
                                                                            characteristics</span></span>
																																	</span>
																																</div>
																															</td>
																															<td style={{textAlign: 'center', borderRight: '1px solid black', borderBottom: '1px solid black', borderTop: '1px solid black', width: '14.9084%'}}>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																	<span data-custom-class="body_text">
                                                                        <span className="block-component">
                                                                        </span> NO
																																	<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                                  <span className="statement-end-if-in-editor">
                                                                                  </span>
																																	</span>
																																	</span>
																																	</span>
																																	</span>
																																	</span>
																																	</span>
																																</div>
																																<div style={{lineHeight: '1.5'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																														<tr>
																															<td style={{borderLeft: '1px solid black', borderRight: '1px solid black', borderBottom: '1px solid black', lineHeight: '1.5'}}>
																																<span data-custom-class="body_text">
                                                                      <span className="block-component">
                                                                      </span> L
																																<span className="else-block">
                                                                      </span> . Sensitive personal Information
																																</span>
																															</td>
																															<td style={{borderRight: '1px solid black', borderBottom: '1px solid black', lineHeight: '1.5'}}>
																																<span className="block-component">
                                                                      <span data-custom-class="body_text" />
                                                                    </span>
																																<span data-custom-class="body_text">
                                                                      <span className="forloop-component">
                                                                      </span>
																																<span className="block-component">
                                                                      </span>
																																<span className="question">
                                                                        Sex
                                                                        life
                                                                        or
                                                                        sexual
                                                                        orientation
                                                                      </span>
																																<span className="else-block">
                                                                      </span>
																																<span className="forloop-component">
                                                                      </span>
																																<span className="block-component">
                                                                      </span> and
																																<span className="question">
                                                                        status
                                                                        as
                                                                        transgender
                                                                        or
                                                                        nonbinary
                                                                      </span>
																																<span className="statement-end-if-in-editor">
                                                                      </span>
																																<span className="forloop-component">
                                                                      </span>
																																</span>
																																<span className="statement-end-if-in-editor">
                                                                      <span data-custom-class="body_text" />
                                                                    </span>
																															</td>
																															<td style={{borderRight: '1px solid black', borderBottom: '1px solid black'}}>
																																<div data-empty="true" style={{textAlign: 'center'}}>
																																	<br />
																																</div>
																																<div data-custom-class="body_text" data-empty="true" style={{textAlign: 'center', lineHeight: '1.5'}}>
																																	<span className="block-component">
                                                                        <span data-custom-class="body_text" />
                                                                      </span>
																																	<span data-custom-class="body_text">YES
                                                                        <span className="else-block">
                                                                        </span></span>
																																</div>
																																<div data-empty="true" style={{textAlign: 'center'}}>
																																	<br />
																																</div>
																															</td>
																														</tr>
																													</tbody>
																												</table>
																												<div style={{lineHeight: '1.5'}}>
																													<span className="block-component">
                                                                <span style={{fontSize: '15px'}} />
                                                              </span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text">We
                                                                  only
                                                                  collect
                                                                  sensitive
                                                                  personal
                                                                  information,
                                                                  as
                                                                  defined
                                                                  by
                                                                  applicable
                                                                  privacy
                                                                  laws
                                                                  or
                                                                  the
                                                                  purposes
                                                                  allowed
                                                                  by
                                                                  law
                                                                  or
                                                                  with
                                                                  your
                                                                  consent.
                                                                  Sensitive
                                                                  personal
                                                                  information
                                                                  may
                                                                  be
                                                                  used,
                                                                  or
                                                                  disclosed
                                                                  to
                                                                  a
                                                                  service
                                                                  provider
                                                                  or
                                                                  contractor,
                                                                  for
                                                                  additional,
                                                                  specified
                                                                  purposes.
                                                                  You
                                                                  may
                                                                  have
                                                                  the
                                                                  right
                                                                  to
                                                                  limit
                                                                  the
                                                                  use
                                                                  or
                                                                  disclosure
                                                                  of
                                                                  your
                                                                  sensitive
                                                                  personal
                                                                  information.
                                                                  <span className="block-component">
                                                                  </span> We do not collect or process sensitive personal information for the purpose of inferring characteristics about you.
																													<span className="statement-end-if-in-editor">
                                                                  </span>
																													</span>
																													<span className="statement-end-if-in-editor">
                                                                </span>
																													</span>
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<br />
																												</div>
																												<div style={{lineHeight: '1.5'}}>
																													<span style={{fontSize: '15px'}}><span data-custom-class="body_text">We
                                                                  may
                                                                  also
                                                                  collect
                                                                  other
                                                                  personal
                                                                  information
                                                                  outside
                                                                  of
                                                                  these
                                                                  categories
                                                                  through
                                                                  instances
                                                                  where
                                                                  you
                                                                  interact
                                                                  with
                                                                  us
                                                                  in
                                                                  person,
                                                                  online,
                                                                  or
                                                                  by
                                                                  phone
                                                                  or
                                                                  mail
                                                                  in
                                                                  the
                                                                  context
                                                                  of:</span>
																													<span className="block-component">
                                                                </span>
																													</span>
																												</div>
																												<ul>
																													<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																														<span style={{fontSize: '15px'}}>Receiving
                                                                  help
                                                                  through
                                                                  our
                                                                  customer
                                                                  support
                                                                  channels;
                                                                  <span className="statement-end-if-in-editor">
                                                                  </span>
																														</span>
																													</li>
																												</ul>
																												<div>
																													<span style={{fontSize: '15px'}}>
                                                                <span className="block-component">
                                                                </span>
																													</span>
																												</div>
																												<ul>
																													<li data-custom-class="body_text">
																														<span style={{fontSize: '15px'}}>Participation
                                                                  in
                                                                  customer
                                                                  surveys
                                                                  or
                                                                  contests;
                                                                  and
                                                                  <span className="statement-end-if-in-editor">
                                                                  </span>
																														</span>
																													</li>
																												</ul>
																												<div>
																													<span style={{fontSize: '15px'}}>
                                                                <span className="block-component">
                                                                </span>
																													</span>
																												</div>
																												<ul>
																													<li data-custom-class="body_text">
																														<span style={{fontSize: '15px'}}>Facilitation
                                                                  in
                                                                  the
                                                                  delivery
                                                                  of
                                                                  our
                                                                  Services
                                                                  and
                                                                  to
                                                                  respond
                                                                  to
                                                                  your
                                                                  inquiries.</span>
																														<span className="statement-end-if-in-editor">
                                                                  <span style={{fontSize: '15px'}} />
                                                                </span>
																													</li>
																												</ul>
																												<div style={{lineHeight: '1.5'}}>
																													<span className="block-component">
                                                                <span data-custom-class="body_text" />
                                                              </span>
																													<span data-custom-class="body_text">We
                                                                will
                                                                use
                                                                and
                                                                retain
                                                                the
                                                                collected
                                                                personal
                                                                information
                                                                as
                                                                needed
                                                                to
                                                                provide
                                                                the
                                                                Services
                                                                or
                                                                for:
                                                                <span className="block-component">
                                                                </span>
																													</span>
																													<div style={{lineHeight: '1.5'}}>
																														<span data-custom-class="body_text">
                                                                  <span className="block-component">
                                                                    <span className="block-component">
                                                                    </span>
																														</span>
																														</span>
																														<div style={{lineHeight: '1.5'}}>
																															<span data-custom-class="body_text">
                                                                    <span className="block-component">
                                                                    </span>
																															</span>
																															<div style={{lineHeight: '1.5'}}>
																																<span data-custom-class="body_text">
                                                                      <span className="block-component">
                                                                      </span>
																																</span>
																																<div style={{lineHeight: '1.5'}}>
																																	<span data-custom-class="body_text">
                                                                        <span className="block-component">
                                                                        </span>
																																	</span>
																																	<div style={{lineHeight: '1.5'}}>
																																		<span data-custom-class="body_text">
                                                                          <span className="block-component">
                                                                          </span>
																																		</span>
																																		<div style={{lineHeight: '1.5'}}>
																																			<span data-custom-class="body_text">
                                                                            <span className="block-component">
                                                                            </span>
																																			</span>
																																			<div style={{lineHeight: '1.5'}}>
																																				<span data-custom-class="body_text">
                                                                              <span className="block-component">
                                                                              </span>
																																				</span>
																																			</div>
																																			<ul>
																																				<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																					<span data-custom-class="body_text">Category
                                                                                <span className="block-component">
                                                                                </span> H
																																					<span className="else-block">
                                                                                </span> -
																																					<span className="question">
                                                                                  As
                                                                                  long
                                                                                  as
                                                                                  the
                                                                                  user
                                                                                  has
                                                                                  an
                                                                                  account
                                                                                  with
                                                                                  us
                                                                                </span>
																																					<span className="statement-end-if-in-editor">
                                                                                </span>
																																					</span>
																																				</li>
																																			</ul>
																																			<div style={{lineHeight: '1.5'}}>
																																				<span data-custom-class="body_text">
                                                                              <span className="block-component">
                                                                              </span>
																																				</span>
																																				<div style={{lineHeight: '1.5'}}>
																																					<span data-custom-class="body_text">
                                                                                <span className="block-component">
                                                                                </span>
																																					</span>
																																					<div style={{lineHeight: '1.5'}}>
																																						<span data-custom-class="body_text">
                                                                                  <span className="block-component">
                                                                                  </span>
																																						</span>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span data-custom-class="body_text">
                                                                                    <span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span data-custom-class="body_text">Category
                                                                                      <span className="block-component">
                                                                                      </span> L
																																								<span className="else-block">
                                                                                      </span> -
																																								<span className="question">
                                                                                        As
                                                                                        long
                                                                                        as
                                                                                        the
                                                                                        user
                                                                                        has
                                                                                        an
                                                                                        account
                                                                                        with
                                                                                        us
                                                                                      </span>
																																								<span className="statement-end-if-in-editor">
                                                                                      </span>
																																								</span>
																																								<span className="statement-end-if-in-editor">
                                                                                      <span data-custom-class="body_text" />
                                                                                    </span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<strong><span style={{fontSize: '15px'}}><span data-custom-class="heading_2">Sources
                                                                                        of
                                                                                        Personal
                                                                                        Information</span></span></strong>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="body_text">Learn
                                                                                      more
                                                                                      about
                                                                                      the
                                                                                      sources
                                                                                      of
                                                                                      personal
                                                                                      information
                                                                                      we
                                                                                      collect
                                                                                      in
                                                                                      <span className="block-component">
                                                                                      </span> "
																																							<span className="statement-end-if-in-editor">
                                                                                      </span>
																																							</span>
																																							</span><span data-custom-class="body_text"><a data-custom-class="link" href="#infocollect"><span style={{color: 'rgb (0, 58, 250)', fontSize: '15px'}}>WHAT
                                                                                        INFORMATION
                                                                                        DO
                                                                                        WE
                                                                                        COLLECT?</span></a>
																																							</span><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                      <span className="block-component">
                                                                                      </span> "
																																							</span>
																																							<span className="statement-end-if-in-editor">
                                                                                      <span data-custom-class="body_text" />
                                                                                    </span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><strong><span data-custom-class="heading_2">How
                                                                                          We
                                                                                          Use
                                                                                          and
                                                                                          Share
                                                                                          Personal
                                                                                          Information</span></strong>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span data-custom-class="body_text" style={{fontSize: '15px'}}>Learn
                                                                                    about
                                                                                    how
                                                                                    we
                                                                                    use
                                                                                    your
                                                                                    personal
                                                                                    information
                                                                                    in
                                                                                    the
                                                                                    section,
                                                                                    <span className="block-component">
                                                                                    </span> "
																																							<span className="statement-end-if-in-editor">
                                                                                    </span>
																																							</span><a data-custom-class="link" href="#infouse"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}>HOW
                                                                                      DO
                                                                                      WE
                                                                                      PROCESS
                                                                                      YOUR
                                                                                      INFORMATION?</span></a><span data-custom-class="body_text" style={{fontSize: '15px'}}>
                                                                                    <span className="block-component">
                                                                                    </span> "
																																							</span>
																																							<span className="statement-end-if-in-editor">
                                                                                    <span data-custom-class="body_text" style={{fontSize: '15px'}} />
                                                                                  </span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                            <span className="block-component">
                                                                                            </span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><strong>Will
                                                                                          your
                                                                                          information
                                                                                          be
                                                                                          shared
                                                                                          with
                                                                                          anyone
                                                                                          else?</strong></span></span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                                        may
                                                                                        disclose
                                                                                        your
                                                                                        personal
                                                                                        information
                                                                                        with
                                                                                        our
                                                                                        service
                                                                                        providers
                                                                                        pursuant
                                                                                        to
                                                                                        a
                                                                                        written
                                                                                        contract
                                                                                        between
                                                                                        us
                                                                                        and
                                                                                        each
                                                                                        service
                                                                                        provider.
                                                                                        Learn
                                                                                        more
                                                                                        about
                                                                                        how
                                                                                        we
                                                                                        disclose
                                                                                        personal
                                                                                        information
                                                                                        to
                                                                                        in
                                                                                        the
                                                                                        section,
                                                                                        <span className="block-component">
                                                                                        </span> "
																																							<span className="statement-end-if-in-editor">
                                                                                        </span>
																																							</span>
																																							</span>
																																							</span><a data-custom-class="link" href="#whoshare"><span style={{fontSize: '15px', color: 'rgb(0, 58, 250)'}}><span style={{fontSize: '15px', color: 'rgb(0, 58, 250)'}}>WHEN
                                                                                        AND
                                                                                        WITH
                                                                                        WHOM
                                                                                        DO
                                                                                        WE
                                                                                        SHARE
                                                                                        YOUR
                                                                                        PERSONAL
                                                                                        INFORMATION?</span></span></a><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                                        <span className="block-component">
                                                                                        </span> "
																																							<span className="statement-end-if-in-editor">
                                                                                        </span>
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                                        may
                                                                                        use
                                                                                        your
                                                                                        personal
                                                                                        information
                                                                                        for
                                                                                        our
                                                                                        own
                                                                                        business
                                                                                        purposes,
                                                                                        such
                                                                                        as
                                                                                        for
                                                                                        undertaking
                                                                                        internal
                                                                                        research
                                                                                        for
                                                                                        technological
                                                                                        development
                                                                                        and
                                                                                        demonstration.
                                                                                        This
                                                                                        is
                                                                                        not
                                                                                        considered
                                                                                        to
                                                                                        be
                                                                                        <span className="block-component">
                                                                                        </span> "selling"
																																							<span className="statement-end-if-in-editor">
                                                                                        </span> of your personal information.
																																							<span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                            <span className="block-component">
                                                                                            </span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                                        have
                                                                                        not
                                                                                        disclosed,
                                                                                        sold,
                                                                                        or
                                                                                        shared
                                                                                        any
                                                                                        personal
                                                                                        information
                                                                                        to
                                                                                        third
                                                                                        parties
                                                                                        for
                                                                                        a
                                                                                        business
                                                                                        or
                                                                                        commercial
                                                                                        purpose
                                                                                        in
                                                                                        the
                                                                                        preceding
                                                                                        twelve
                                                                                        (12)
                                                                                        months.
                                                                                        We<span style={{color: '#f3f3f3'}}>\'a0</span>will not sell or share personal information in the future belonging to website visitors, users, and other consumers.
																																							<span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                                                    <span className="statement-end-if-in-editor">
                                                                                                    </span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							<span className="block-component">
                                                                                            </span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							<span data-custom-class="body_text"><span style={{color: 'rgb(0, 0, 0)'}}><span data-custom-class="body_text">
                                                                                        <span className="block-component">
                                                                                        </span>
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><strong><span data-custom-class="heading_2">Your
                                                                                        Rights</span></strong>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><br /></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="body_text">You
                                                                                      have
                                                                                      rights
                                                                                      under
                                                                                      certain
                                                                                      US
                                                                                      state
                                                                                      data
                                                                                      protection
                                                                                      laws.
                                                                                      However,
                                                                                      these
                                                                                      rights
                                                                                      are
                                                                                      not
                                                                                      absolute,
                                                                                      and
                                                                                      in
                                                                                      certain
                                                                                      cases,
                                                                                      we
                                                                                      may
                                                                                      decline
                                                                                      your
                                                                                      request
                                                                                      as
                                                                                      permitted
                                                                                      by
                                                                                      law.
                                                                                      These
                                                                                      rights
                                                                                      include:</span>
																																							<span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}><strong>Right
                                                                                        to
                                                                                        know</strong>
                                                                                      whether
                                                                                      or
                                                                                      not
                                                                                      we
                                                                                      are
                                                                                      processing
                                                                                      your
                                                                                      personal
                                                                                      data
                                                                                      <span className="statement-end-if-in-editor">
                                                                                      </span>
																																								</span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}>
                                                                                    <span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}><strong>Right
                                                                                        to
                                                                                        access\'a0</strong>your
                                                                                      personal
                                                                                      data
                                                                                      <span className="statement-end-if-in-editor">
                                                                                      </span>
																																								</span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}>
                                                                                    <span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}><strong>Right
                                                                                        to
                                                                                        correct\'a0</strong>inaccuracies
                                                                                      in
                                                                                      your
                                                                                      personal
                                                                                      data
                                                                                      <span className="statement-end-if-in-editor">
                                                                                      </span>
																																								</span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}>
                                                                                    <span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}><strong>Right
                                                                                        to
                                                                                        request</strong>
                                                                                      the
                                                                                      deletion
                                                                                      of
                                                                                      your
                                                                                      personal
                                                                                      data
                                                                                      <span className="statement-end-if-in-editor">
                                                                                      </span>
																																								</span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}>
                                                                                    <span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}><strong>Right
                                                                                        to
                                                                                        obtain
                                                                                        a
                                                                                        copy\'a0</strong>of
                                                                                      the
                                                                                      personal
                                                                                      data
                                                                                      you
                                                                                      previously
                                                                                      shared
                                                                                      with
                                                                                      us
                                                                                      <span className="statement-end-if-in-editor">
                                                                                      </span>
																																								</span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}>
                                                                                    <span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}><strong>Right
                                                                                        to
                                                                                        non-discrimination</strong>
                                                                                      for
                                                                                      exercising
                                                                                      your
                                                                                      rights
                                                                                      <span className="statement-end-if-in-editor">
                                                                                      </span>
																																								</span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}>
                                                                                    <span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}><strong>Right
                                                                                        to
                                                                                        opt
                                                                                        out</strong>
                                                                                      of
                                                                                      the
                                                                                      processing
                                                                                      of
                                                                                      your
                                                                                      personal
                                                                                      data
                                                                                      if
                                                                                      it
                                                                                      is
                                                                                      used
                                                                                      for
                                                                                      targeted
                                                                                      advertising
                                                                                      <span className="block-component">
                                                                                      </span> (or sharing as defined under California\'92s privacy law)
																																								<span className="statement-end-if-in-editor">
                                                                                      </span> , the sale of personal data, or profiling in furtherance of decisions that produce legal or similarly significant effects (
																																								<span className="block-component">
                                                                                      </span> "profiling"
																																								<span className="statement-end-if-in-editor">
                                                                                      </span> )
																																								<span className="statement-end-if-in-editor">
                                                                                      </span>
																																								</span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}>
                                                                                    <span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="body_text">Depending
                                                                                      upon
                                                                                      the
                                                                                      state
                                                                                      where
                                                                                      you
                                                                                      live,
                                                                                      you
                                                                                      may
                                                                                      also
                                                                                      have
                                                                                      the
                                                                                      following
                                                                                      rights:</span>
																																							<span className="block-component">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}>Right
                                                                                      to
                                                                                      obtain
                                                                                      a
                                                                                      list
                                                                                      of
                                                                                      the
                                                                                      categories
                                                                                      of
                                                                                      third
                                                                                      parties
                                                                                      to
                                                                                      which
                                                                                      we
                                                                                      have
                                                                                      disclosed
                                                                                      personal
                                                                                      data
                                                                                      (as
                                                                                      permitted
                                                                                      by
                                                                                      applicable
                                                                                      law,
                                                                                      including
                                                                                      <span className="block-component">
                                                                                      </span> California's and Delaware's
																																								<span className="else-block">
                                                                                      </span> privacy law)
																																								<span className="statement-end-if-in-editor">
                                                                                      </span>
																																								</span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}} />
                                                                                  </span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}>Right
                                                                                      to
                                                                                      obtain
                                                                                      a
                                                                                      list
                                                                                      of
                                                                                      specific
                                                                                      third
                                                                                      parties
                                                                                      to
                                                                                      which
                                                                                      we
                                                                                      have
                                                                                      disclosed
                                                                                      personal
                                                                                      data
                                                                                      (as
                                                                                      permitted
                                                                                      by
                                                                                      applicable
                                                                                      law,
                                                                                      including
                                                                                      Oregon\'92s
                                                                                      privacy
                                                                                      law)</span>
																																								<span className="statement-end-if-in-editor">
                                                                                      <span style={{fontSize: '15px'}} />
                                                                                    </span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}} />
                                                                                  </span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}>Right
                                                                                      to
                                                                                      limit
                                                                                      use
                                                                                      and
                                                                                      disclosure
                                                                                      of
                                                                                      sensitive
                                                                                      personal
                                                                                      data
                                                                                      (as
                                                                                      permitted
                                                                                      by
                                                                                      applicable
                                                                                      law,
                                                                                      including
                                                                                      California\'92s
                                                                                      privacy
                                                                                      law)</span>
																																								<span className="statement-end-if-in-editor">
                                                                                      <span style={{fontSize: '15px'}} />
                                                                                    </span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}} />
                                                                                  </span>
																																						</div>
																																						<ul>
																																							<li data-custom-class="body_text" style={{lineHeight: '1.5'}}>
																																								<span style={{fontSize: '15px'}}>Right
                                                                                      to
                                                                                      opt
                                                                                      out
                                                                                      of
                                                                                      the
                                                                                      collection
                                                                                      of
                                                                                      sensitive
                                                                                      data
                                                                                      and
                                                                                      personal
                                                                                      data
                                                                                      collected
                                                                                      through
                                                                                      the
                                                                                      operation
                                                                                      of
                                                                                      a
                                                                                      voice
                                                                                      or
                                                                                      facial
                                                                                      recognition
                                                                                      feature
                                                                                      (as
                                                                                      permitted
                                                                                      by
                                                                                      applicable
                                                                                      law,
                                                                                      including
                                                                                      Florida\'92s
                                                                                      privacy
                                                                                      law)</span>
																																								<span className="statement-end-if-in-editor">
                                                                                      <span style={{fontSize: '15px'}} />
                                                                                    </span>
																																							</li>
																																						</ul>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}>
                                                                                    <span className="statement-end-if-in-editor">
                                                                                    </span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<strong><span style={{fontSize: '15px'}}><span data-custom-class="heading_2">How
                                                                                        to
                                                                                        Exercise
                                                                                        Your
                                                                                        Rights</span></span></strong>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">To
                                                                                        exercise
                                                                                        these
                                                                                        rights,
                                                                                        you
                                                                                        can
                                                                                        contact
                                                                                        us
                                                                                        <span className="block-component">
                                                                                        </span> by submitting a\'a0
																																							</span>
																																							</span>
																																							</span><a data-custom-class="link" href="https://app.termly.io/notify/6c84b209-c0a2-4278-8690-da91c4609e50" rel="noopener noreferrer" target="_blank"><span style={{fontSize: '15px', color: 'rgb(0, 58, 250)'}}><span style={{fontSize: '15px', color: 'rgb(0, 58, 250)'}}>data
                                                                                        subject
                                                                                        access
                                                                                        request</span></span></a><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">,
                                                                                        <span className="block-component">
                                                                                        </span>
																																							</span><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                              <span className="block-component">
                                                                                              </span> by emailing us at
																																							<span className="question">
                                                                                                ntkcllc@gmail.com
                                                                                              </span> ,
																																							<span className="statement-end-if-in-editor">
                                                                                              </span>
																																							<span className="block-component">
                                                                                              </span>
																																							</span><span data-custom-class="body_text">
                                                                                              <span className="block-component">
                                                                                              </span>
																																							<span className="block-component">
                                                                                                <span data-custom-class="body_text">
                                                                                                  <span className="block-component">
                                                                                                  </span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span><span data-custom-class="body_text">or
                                                                                    by
                                                                                    referring
                                                                                    to
                                                                                    the
                                                                                    contact
                                                                                    details
                                                                                    at
                                                                                    the
                                                                                    bottom
                                                                                    of
                                                                                    this
                                                                                    document.</span>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}} />
                                                                                  </span>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}} />
                                                                                  </span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="body_text">Under
                                                                                      certain
                                                                                      US
                                                                                      state
                                                                                      data
                                                                                      protection
                                                                                      laws,
                                                                                      you
                                                                                      can
                                                                                      designate
                                                                                      an
                                                                                      <span className="block-component">
                                                                                      </span> authorized
																																							<span className="statement-end-if-in-editor">
                                                                                      </span> agent to make a request on your behalf. We may deny a request from an
																																							<span className="block-component">
                                                                                      </span> authorized
																																							<span className="statement-end-if-in-editor">
                                                                                      </span> agent that does not submit proof that they have been validly
																																							<span className="block-component">
                                                                                      </span> authorized
																																							<span className="statement-end-if-in-editor">
                                                                                      </span> to act on your behalf in accordance with applicable laws.
																																							</span><br /></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><strong><span data-custom-class="heading_2">Request
                                                                                        Verification</span></strong>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><br /></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="body_text">Upon
                                                                                      receiving
                                                                                      your
                                                                                      request,
                                                                                      we
                                                                                      will
                                                                                      need
                                                                                      to
                                                                                      verify
                                                                                      your
                                                                                      identity
                                                                                      to
                                                                                      determine
                                                                                      you
                                                                                      are
                                                                                      the
                                                                                      same
                                                                                      person
                                                                                      about
                                                                                      whom
                                                                                      we
                                                                                      have
                                                                                      the
                                                                                      information
                                                                                      in
                                                                                      our
                                                                                      system.
                                                                                      We
                                                                                      will
                                                                                      only
                                                                                      use
                                                                                      personal
                                                                                      information
                                                                                      provided
                                                                                      in
                                                                                      your
                                                                                      request
                                                                                      to
                                                                                      verify
                                                                                      your
                                                                                      identity
                                                                                      or
                                                                                      authority
                                                                                      to
                                                                                      make
                                                                                      the
                                                                                      request.
                                                                                      However,
                                                                                      if
                                                                                      we
                                                                                      cannot
                                                                                      verify
                                                                                      your
                                                                                      identity
                                                                                      from
                                                                                      the
                                                                                      information
                                                                                      already
                                                                                      maintained
                                                                                      by
                                                                                      us,
                                                                                      we
                                                                                      may
                                                                                      request
                                                                                      that
                                                                                      you
                                                                                      provide
                                                                                      additional
                                                                                      information
                                                                                      for
                                                                                      the
                                                                                      purposes
                                                                                      of
                                                                                      verifying
                                                                                      your
                                                                                      identity
                                                                                      and
                                                                                      for
                                                                                      security
                                                                                      or
                                                                                      fraud-prevention
                                                                                      purposes.</span></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><br /></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="body_text">If
                                                                                      you
                                                                                      submit
                                                                                      the
                                                                                      request
                                                                                      through
                                                                                      an
                                                                                      <span className="block-component">
                                                                                      </span> authorized
																																							<span className="statement-end-if-in-editor">
                                                                                      </span> agent, we may need to collect additional information to verify your identity before processing your request and the agent will need to provide a written and signed permission from you to submit such request on your behalf.
																																							</span>
																																							</span>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}} />
                                                                                  </span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><br /></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="heading_2"><strong>Appeals</strong></span></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><br /></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="body_text">Under
                                                                                      certain
                                                                                      US
                                                                                      state
                                                                                      data
                                                                                      protection
                                                                                      laws,
                                                                                      if
                                                                                      we
                                                                                      decline
                                                                                      to
                                                                                      take
                                                                                      action
                                                                                      regarding
                                                                                      your
                                                                                      request,
                                                                                      you
                                                                                      may
                                                                                      appeal
                                                                                      our
                                                                                      decision
                                                                                      by
                                                                                      emailing
                                                                                      us
                                                                                      at
                                                                                      <span className="block-component">
                                                                                      </span>
																																							<span className="question">
                                                                                        NTKCLLC@gmail.com
                                                                                      </span>
																																							<span className="else-block">
                                                                                      </span> . We will inform you in writing of any action taken or not taken in response to the appeal, including a written explanation of the reasons for the decisions. If your appeal is denied, you may submit a complaint to your state attorney general.
																																							</span>
																																							<span className="statement-end-if-in-editor">
                                                                                    </span>
																																							</span><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                          <span className="block-component">
                                                                                            <span className="block-component">
                                                                                            </span></span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}} />
                                                                                  </span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><br /></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><strong><span data-custom-class="heading_2">California
                                                                                        <span className="block-component">
                                                                                        </span> "Shine The Light"
																																							<span className="statement-end-if-in-editor">
                                                                                        </span> Law
																																							</span>
																																							</strong>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><br /></span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="body_text">California
                                                                                      Civil
                                                                                      Code
                                                                                      Section
                                                                                      1798.83,
                                                                                      also
                                                                                      known
                                                                                      as
                                                                                      the
                                                                                      <span className="block-component">
                                                                                      </span> "Shine The Light"
																																							<span className="statement-end-if-in-editor">
                                                                                      </span> law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us by using the contact details provided in the section
																																							<span className="block-component">
                                                                                      </span> "
																																							<span className="statement-end-if-in-editor">
                                                                                      </span>
																																							</span>
																																							</span><span data-custom-class="body_text"><a data-custom-class="link" href="#contact"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}>HOW
                                                                                        CAN
                                                                                        YOU
                                                                                        CONTACT
                                                                                        US
                                                                                        ABOUT
                                                                                        THIS
                                                                                        NOTICE?</span></a>
																																							</span><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                      <span className="block-component">
                                                                                      </span> "
																																							</span>
																																							<span className="statement-end-if-in-editor">
                                                                                      <span data-custom-class="body_text" />
                                                                                    </span>
																																							</span>
																																							<span className="statement-end-if-in-editor">
                                                                                    <span style={{fontSize: '15px'}} />
                                                                                  </span>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                                      <span className="statement-end-if-in-editor">
                                                                                                        <span data-custom-class="body_text"><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                                                              <span className="statement-end-if-in-editor">
                                                                                                                                <span className="statement-end-if-in-editor">
                                                                                                                                </span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}}>
                                                                                    </span></span>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}} />
                                                                                  </span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div id="policyupdates" style={{lineHeight: '1.5'}}>
																																							<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">13.
                                                                                                DO
                                                                                                WE
                                                                                                MAKE
                                                                                                UPDATES
                                                                                                TO
                                                                                                THIS
                                                                                                NOTICE?</span></strong>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text"><em><strong>In
                                                                                            Short:\'a0</strong>Yes,
                                                                                          we
                                                                                          will
                                                                                          update
                                                                                          this
                                                                                          notice
                                                                                          as
                                                                                          necessary
                                                                                          to
                                                                                          stay
                                                                                          compliant
                                                                                          with
                                                                                          relevant
                                                                                          laws.</em></span></span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">We
                                                                                        may
                                                                                        update
                                                                                        this
                                                                                        privacy
                                                                                        notice
                                                                                        from
                                                                                        time
                                                                                        to
                                                                                        time.
                                                                                        The
                                                                                        updated
                                                                                        version
                                                                                        will
                                                                                        be
                                                                                        indicated
                                                                                        by
                                                                                        an
                                                                                        updated
                                                                                        <span className="block-component">
                                                                                        </span> "Revised"
																																							<span className="statement-end-if-in-editor">
                                                                                        </span> date at the top of this privacy notice. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div id="contact" style={{lineHeight: '1.5'}}>
																																							<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">14.
                                                                                                HOW
                                                                                                CAN
                                                                                                YOU
                                                                                                CONTACT
                                                                                                US
                                                                                                ABOUT
                                                                                                THIS
                                                                                                NOTICE?</span></strong>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">If
                                                                                        you
                                                                                        have
                                                                                        questions
                                                                                        or
                                                                                        comments
                                                                                        about
                                                                                        this
                                                                                        notice,
                                                                                        you
                                                                                        may
                                                                                        <span style={{color: '#f3f3f3', fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                            <span className="block-component">
                                                                                              <span className="block-component">
                                                                                              </span>
																																							</span>
																																							email us at
																																							<span className="question">
                                                                                              ntkcllc@gmail.com
                                                                                              or\'a0
                                                                                            </span>
																																							<span className="statement-end-if-in-editor">
                                                                                              <span className="block-component">
                                                                                              </span>
																																							</span>
																																							</span>
																																							</span><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">contact
                                                                                              us
                                                                                              by
                                                                                              post
                                                                                              at:</span></span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>

																																						<div style={{lineHeight: '1.5'}}>
																																							<span data-custom-class="body_text" style={{fontSize: '15px'}}>
                                                                                  </span>
																																							<span className="block-component">
                                                                                    <span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                      </span></span>
																																							</span>
																																							<span className="statement-end-if-in-editor">
                                                                                  </span>
																																							<span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}><span style={{fontSize: '15px'}}>
                                                                                        <span className="statement-end-if-in-editor">
                                                                                        </span>
																																							</span>
																																							</span>
																																							</span>
																																							<span data-custom-class="body_text"><span style={{fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3'}}>
                                                                                          <span className="statement-end-if-in-editor">
                                                                                            <span style={{color: '#f3f3f3'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                                  <span className="block-component">
                                                                                                    <span className="block-component">
                                                                                                    </span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							<span className="block-component">
                                                                                      <span style={{fontSize: '15px'}} />
                                                                                    </span>
																																							<span style={{fontSize: '15px'}}><span data-custom-class="body_text"><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px'}}><span data-custom-class="body_text">
                                                                                              <span className="statement-end-if-in-editor">
                                                                                                <span className="block-component">
                                                                                                </span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div id="request" style={{lineHeight: '1.5'}}>
																																							<span style={{color: '#f3f3f3f3'}}><span style={{color: '#f3f3f3', fontSize: '15px'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span id="control" style={{color: 'rgb(0, 0, 0)'}}><strong><span data-custom-class="heading_1">15.
                                                                                                HOW
                                                                                                CAN
                                                                                                YOU
                                                                                                REVIEW,
                                                                                                UPDATE,
                                                                                                OR
                                                                                                DELETE
                                                                                                THE
                                                                                                DATA
                                                                                                WE
                                                                                                COLLECT
                                                                                                FROM
                                                                                                YOU?</span></strong>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																							</span>
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<br />
																																						</div>
																																						<div style={{lineHeight: '1.5'}}>
																																							<span style={{fontSize: '15px', color: '#f3f3f3'}}><span style={{fontSize: '15px', color: '#f3f3f3'}}><span data-custom-class="body_text">
                                                                                        <span className="block-component">
                                                                                        </span> Based on the applicable laws of your country
																																							<span className="block-component">
                                                                                        </span> or state of residence in the US
																																							<span className="statement-end-if-in-editor">
                                                                                        </span> , you may
																																							<span className="else-block">
                                                                                          <span className="block-component">
                                                                                            have
                                                                                            the
                                                                                            right
                                                                                            to
                                                                                            request
                                                                                            access
                                                                                            to
                                                                                            the
                                                                                            personal
                                                                                            information
                                                                                            we
                                                                                            collect
                                                                                            from
                                                                                            you,
                                                                                            details
                                                                                            about
                                                                                            how
                                                                                            we
                                                                                            have
                                                                                            processed
                                                                                            it,
                                                                                            correct
                                                                                            inaccuracies,
                                                                                            or
                                                                                            delete
                                                                                            your
                                                                                            personal
                                                                                            information.
                                                                                            You
                                                                                            may
                                                                                            also
                                                                                            have
                                                                                            the
                                                                                            right
                                                                                            to
                                                                                            withdraw
                                                                                            your
                                                                                            consent
                                                                                            to
                                                                                            our
                                                                                            processing
                                                                                            of
                                                                                            your
                                                                                            personal
                                                                                            information.
                                                                                            These
                                                                                            rights
                                                                                            may
                                                                                            be
                                                                                            limited
                                                                                            in
                                                                                            some
                                                                                            circumstances
                                                                                            by
                                                                                            applicable
                                                                                            law.
                                                                                            To
                                                                                            request
                                                                                            to
                                                                                            review,
                                                                                            update,
                                                                                            or
                                                                                            delete
                                                                                            your
                                                                                            personal
                                                                                            information,
                                                                                            please
                                                                                            <span className="block-component">
                                                                                            </span> fill out and submit a\'a0
																																							</span>
																																							</span>
																																							</span><span style={{color: 'rgb(0, 58, 250)'}}><span data-custom-class="body_text"><span style={{color: 'rgb(0, 58, 250)', fontSize: '15px'}}><a data-custom-class="link" href="https://app.termly.io/notify/6c84b209-c0a2-4278-8690-da91c4609e50" rel="noopener noreferrer" target="_blank">data
                                                                                              subject
                                                                                              access
                                                                                              request</a></span></span>
																																							</span>
																																							<span className="block-component">
                                                                                        <span data-custom-class="body_text">
                                                                                        </span></span>
																																							</span>
																																							</span><span data-custom-class="body_text">.</span>
																																						</div>
																																						<style dangerouslySetInnerHTML={{__html: "\n" }} />
																																					</div>
																																				</div>
																																			</div>
																																		</div>
																																	</div>
																																</div>
																															</div>
																														</div>
																													</div>
																												</div>
																											</div>
																										</div>
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
  );
}

export default PrivacyPolicy;